export default {
  generationFailureDialog: {
    title: "生成失敗",
    message: "AI 服務暫時不可用，請稍後重試。",
    fallbackDetail: "這可能是因為網絡波動或伺服器繁忙。",
    refundText: "積分已退回",
    retryText: "重新生成",
    backText: "返回",
  },
  dashboard: {
    title: "工作台",
    welcome: "歡迎返嚟，{name} · {date}",
    creator: "創作者",
    metricsLabel: "工作台數據概覽",
    pointsBalance: "積分消耗（近7日）",
    workflowTotal: "漫劇製作流程-影片時長（近7日）",
    canvasTotal: "畫布-影片時長（近7日）",
    scriptTotal: "劇本集數（近7日）",
    pointsUnit: "積分",
    secondsUnit: "秒",
    episodesUnit: "集",
    changeRate: "環比 {value}%",
    noChange: "環比 --",
    recentWorkflow: "最近漫劇製作流程項目",
    recentCanvas: "最近畫布項目",
    recentScripts: "最近劇本",
    workflowProjects: "漫劇項目",
    canvasProjects: "畫布項目",
    trendTitle: "近 30 日積分消耗趨勢",
    trendAria: "近 30 日漫劇項目同畫布項目建立趨勢圖",
    viewAll: "全部",
    view: "查看",
    download: "下載",
    downloadFailed: "劇本下載失敗，請稍後再試",
    emptyProjects: "暫時未有項目",
    emptyScripts: "暫時未有劇本",
    untitled: "未命名",
    script: "劇本",
    episodes: "{count} 集",
    styleUnset: "未設定風格",
    recently: "最近更新",
    today: "今日",
    yesterday: "琴日",
    daysAgo: "{count} 日前",
  },
  common: {
    language: "語言",
    loading: "載入緊...",
    uploading: "上載緊...",
    search: "搜尋",
    cancel: "取消",
    confirm: "確定",
    tip: "提示",
    saveChanges: "儲存修改",
    save: "儲存",
    edit: "編輯",
    delete: "刪除",
    select: "請選擇",
    clickSelect: "撳呢度選擇",
    selectAll: "全選",
    batchGenerate: "批量生成",
    generating: "生成中",
  },
  confirmDialog: {
    logout: {
      title: "登出？",
      message: "登出唔會令任何資料遺失，你隨時都可以重新登入呢個帳戶。",
      confirm: "登出",
    },
  },
  teamManagementPage: {
    title: "團隊管理",
    currentTeam: "目前團隊共有",
    people: "人",
    seats: "席位",
    createAccount: "建立帳戶",
    inviteMember: "邀請成員",
    invite: {
      title: "產生邀請連結",
      generatedTitle: "邀請連結已產生",
      close: "關閉邀請成員視窗",
      link: "邀請連結",
      generateLink: "產生邀請連結",
      copyLink: "一鍵複製",
      resultTip: "將連結傳送畀成員，對方完成註冊後就可以加入團隊。",
      copySuccess: "已複製邀請連結",
      copyFailed: "複製邀請連結失敗",
      generateFailed: "產生邀請連結失敗",
    },
    subscriptionTip: "訂閱積分會按月到期清零，唔會跨月累積。",
    searchPlaceholder: "搜尋成員暱稱或者手機號碼...",
    cards: {
      totalPoints: "可分配總積分",
      rechargePoints: "可分配增值積分",
      subscriptionPoints: "可分配訂閱積分",
      totalConsumed: "總積分消耗",
      rechargeConsumed: "一般增值積分消耗",
      subscriptionConsumed: "訂閱積分消耗",
    },
    columns: {
      nickname: "暱稱",
      accountLevel: "帳號層級",
      role: "角色",
      parentAdmin: "所屬管理員",
      phone: "手機號碼",
      rechargeRemaining: "增值積分剩餘",
      rechargeUsed: "增值積分已用",
      subscriptionRemaining: "訂閱積分剩餘",
      subscriptionUsed: "訂閱積分已用",
      status: "帳戶狀態",
      createdAt: "建立時間",
      lastLogin: "最後登入",
      actions: "操作",
    },
    disabled: "停用",
    enabled: "啟用",
    allocatePoints: "分配積分",
    resetPassword: "重設密碼",
    remove: "移除",
    totalPeople: "共 {count} 人",
    editMember: "編輯成員",
    badges: {
      defaultAdmin: "預設管理員",
      defaultAdminTip: "預設管理員不可登入，超級管理員持有管理權限",
    },
    accountTypes: {
      superAdmin: "超級管理員",
      levelOneAdmin: "管理員",
      levelTwoAdmin: "子管理員",
      admin: "管理員",
      member: "成員",
    },
    form: {
      nickname: "暱稱",
      nicknamePlaceholder: "成員暱稱",
      username: "用戶名",
      usernamePlaceholder: "請輸入用戶名",
      accountType: "帳號類型",
      accountTypePlaceholder: "請選擇帳號類型",
      role: "業務角色",
      rolePlaceholder: "請選擇業務角色",
      parentAdmin: "所屬管理員",
      parentAdminPlaceholder: "請選擇所屬管理員",
      phone: "手機號碼",
      phonePlaceholder: "11 位手機號碼",
      password: "設定密碼",
      confirmPassword: "確認密碼",
    },
    roleHelp: {
      ariaLabel: "查看角色權限說明",
      producer: {
        title: "製片",
        optionDescription: "最高權限，可建立及分配項目",
        description:
          "擁有團隊最高權限，可建立及分配項目與素材，並管理項目內所有內容。",
        scope: "可以查看自己建立及獲分配嘅項目。",
      },
      director: {
        title: "導演",
        optionDescription: "唔可以建立項目，獲分配後參與協作",
        description:
          "唔可以建立項目，獲分配後先可以進入項目協作，並編輯項目內嘅劇本、分鏡同素材。",
        scope: "只可以查看分配畀你嘅項目。",
      },
      operator: {
        title: "操作員",
        optionDescription: "唔可以建立項目，權限由管理員分配",
        description:
          "唔可以建立項目，獲分配後先可以進入項目協作，具體操作範圍由管理員分配嘅權限決定。",
        scope: "只可以查看分配畀你嘅項目。",
      },
      adminNote:
        "數據範圍按帳號層級裁剪：超級管理員睇本企業全部；一級睇自己分支；二級睇本人同直屬成員。顯式授權只對被授權人有效。無限畫布項目唔受此限制，各角色都可以自行建立。",
    },
    unbound: "未綁定",
    verified: "已驗證",
    initialPoints: "初始積分分配（選填）",
    rechargePoints: "增值積分",
    subscriptionPoints: "訂閱積分",
    pointsUnit: "積分",
    rechargePoolRemaining: "本人可分配增值積分",
    subscriptionPoolRemaining: "本人可分配訂閱積分",
    pointsReadonly: "積分資料（只讀）",
    removeMember: "移除成員",
    pointsDialog: {
      pointType: "積分類型",
      poolOption: "{type}（本人剩餘：{points}）",
      addPoints: "增加積分",
      addDescription: "由本人帳戶劃撥畀呢個帳號（本人剩餘 {points}）",
      reclaimPoints: "收回積分",
      reclaimDescription: "由呢個帳號收回至本人帳戶（對方剩餘 {points}）",
      amountPlaceholder: "請輸入積分數量",
      confirmAllocate: "確認分配",
      add: "增加",
      reclaim: "收回",
      amountLabel: "{action}{type}數額",
      teamPoolRemaining: "本人{type}剩餘 ",
      memberRemaining: "呢個帳號{type}目前剩餘 ",
    },
    validation: {
      phoneRequired: "請輸入手機號碼",
      phoneInvalid: "請輸入有效嘅手機號碼",
      phoneLength: "請輸入 11 位手機號碼",
      pointsRequired: "請輸入積分數量",
      pointsExceeded: "超出可分配額度",
      roleRequired: "請選擇業務角色",
      accountTypeRequired: "請選擇帳號類型",
      parentAdminRequired: "請選擇所屬管理員",
      nicknameRequired: "請輸入暱稱",
      pointTypeRequired: "請選擇積分類型",
      operationRequired: "請選擇操作",
      passwordRequired: "密碼唔可以留空",
      passwordMin: "密碼至少要有 6 位",
      confirmPasswordRequired: "請再次輸入密碼",
      passwordMismatch: "兩次輸入嘅密碼唔一致",
      usernameRequired: "請輸入用戶名",
    },
    time: {
      justNow: "啱啱",
      minutesAgo: "{n} 分鐘前",
      hoursAgo: "{n} 小時前",
      daysAgo: "{n} 日前",
    },
    memberFallback: "員",
    roles: {
      owner: "擁有者",
      producer: "製片",
      director: "導演",
      operator: "操作員",
    },
    messages: {
      success: "操作成功",
      failed: "操作失敗",
      statusUpdated: "帳戶狀態已更新",
      statusUpdateFailed: "帳戶狀態更新失敗",
      overviewFailed: "取得團隊總覽失敗",
      membersFailed: "取得成員列表失敗",
      removeSuccess: "移除成功",
      removeFailed: "移除失敗",
      resetPasswordFailed: "重設密碼失敗",
      hasChildren: "呢個帳號仲有直屬下級，請先調整下級歸屬再刪除",
    },
    removeConfirm: {
      title: "確定要移除「{name}」？",
      message:
        "移除之後呢個帳戶會被刪除，剩餘增值積分同訂閱積分會轉入直屬上級。若仲有直屬下級，就唔可以刪除。",
      confirm: "確定移除",
    },
    statusConfirm: {
      enableTitle: "確定要啟用「{name}」？",
      enableMessage: "啟用之後，呢個帳戶可以重新登入同使用，係咪確認啟用？",
      enableConfirm: "確定啟用",
      disableTitle: "確定要停用「{name}」？",
      disableMessage: "停用之後，呢個帳戶將無法登入同使用，係咪確認停用？",
      disableConfirm: "確定停用",
    },
    resetPasswordConfirm: {
      title: "確定要重設「{name}」嘅密碼？",
      message: "重設之後會產生新密碼，原密碼會即時失效，係咪確認重設？",
      confirm: "確定重設",
    },
    resetPasswordResult: {
      title: "重設密碼",
      target: "重設對象",
      newPassword: "重設後密碼",
      tip: "請盡快通知用戶用新密碼登入，並提醒登入後盡快修改密碼。",
      close: "關閉",
      copy: "複製",
      copySuccess: "密碼已複製",
      copyFailed: "複製失敗",
    },
  },
  app: {
    title: "AI NINJA-AI漫短劇創作管理平台",
    firstLogin: {
      title: "積分分配說明",
      welcome: "歡迎企業版用戶登入。",
      gift: "已送咗積分去超級管理員帳戶，請先到「團隊管理」頁面{action}。",
      action: "分配後使用",
      followUp:
        "之後增值購買嘅積分會進入對應帳號；管理員要由本人帳戶分配畀團隊成員先可以用。",
      allocate: "去分配",
      dismiss: "我知喇，暫時唔分配",
    },
  },
  activityBanner: {
    ariaLabel: "限時會員優惠",
    remaining: "活動剩餘",
    days: "日",
    hours: "時",
    minutes: "分",
    seconds: "秒",
    longTerm: "長期有效",
    title: "Seedance 2.5 720P 年度會員限時優惠",
    description: "生成低至 0.39 元/秒，年度會員最低 4.5 折",
    action: "限時搶購",
    close: "關閉活動橫幅",
  },
  header: {
    logoAlt: "AI漫劇創作平台",
    taskCenter: {
      title: "任務中心",
      open: "打開任務中心",
      close: "關閉任務中心",
      typeLabel: "任務類型",
      taskTitle: "{type}生成任務 #{index}",
      points: "-{points}積分",
      sourceDescription: "定位到漫劇/畫布/劇本-項目名-集數名-分鏡...",
      failureReason: "失敗原因",
      timeoutReason: "生成服務回應逾時",
      reportError: "一鍵反饋",
      report: {
        title: "提交任務錯誤",
        subtitle: "{task} · 消耗 {points} 積分",
        close: "關閉提交任務錯誤彈窗",
        summary: "錯誤摘要（唯讀）",
        description: "用一句話描述你遇到嘅問題",
        placeholder: "例如：角色生成到 80% 後停止，冇返回結果",
        descriptionRequired: "請輸入問題描述",
        cancel: "取消",
        submit: "提交錯誤",
      },
      tasks: {
        scriptAnalysis: "劇本分析",
        characterAsset: "角色資產生成",
        sceneAsset: "場景資產生成",
        styleTransfer: "風格遷移",
        coverImage: "封面圖生成",
        storyboard: "分鏡生成",
      },
      scrollForMore: "向下捲動載入更多",
      allLoaded: "已載入全部",
      empty: "暫時未有任務",
      loadFailed: "任務載入失敗，請稍後再試",
      status: { all: "全部", running: "進行中", success: "已完成", failed: "失敗" },
      type: { image: "圖片任務", video: "影片任務" },
      description: {
        running: "生成中 · {time}",
        success: "生成完成 · {time}",
        failed: "生成失敗 · {time}",
      },
    },
    nav: {
      home: "首頁",
      workflow: "漫劇製作流程",
      canvas: "無限畫布",
      scriptCreation: "劇本創作",
      dataInsights: "數據分析",
      efficiencyAnalysis: "團隊效能分析",
      help: "使用幫助",
      guide: "操作指南",
      productUpdates: "產品動態",
    },
    language: {
      label: "切換語言",
      zhCN: "簡體中文",
      enUS: "English",
      yueHK: "繁中",
      shortZhCN: "中文",
      shortEnUS: "EN",
      shortYueHK: "繁中",
    },
    accountMenu: {
      currentAccount: "目前帳戶",
      personalCenter: "個人中心",
      changePassword: "修改密碼",
      teamManagement: "團隊管理",
      invoice: "訂單管理",
      rechargeRecords: "增值記錄",
      filingInfo: "備案資訊",
      feedback: "問題反映",
      contactUs: "聯絡我哋",
      changelog: "更新日誌",
      language: "語言",
      logout: "登出",
    },
    passwordDialog: {
      title: "重設密碼",
      oldPassword: "原密碼",
      newPassword: "新密碼",
      confirmNewPassword: "確認新密碼",
      enterOldPassword: "請輸入原密碼",
      enterNewPassword: "請輸入新密碼",
      enterConfirmPassword: "請再次輸入新密碼",
      passwordMismatch: "兩次輸入嘅密碼唔一致！",
      success: "密碼修改成功",
    },
    contactDialog: {
      title: "聯絡客服",
      description:
        "如果有任何使用問題、增值或訂閱查詢，或者意見建議，歡迎掃碼加客服微信，我哋會盡快為你解答。",
      qrCodeAlt: "客服微信二維碼",
    },
    feedbackDialog: {
      bugHint: "功能異常、生成失敗、頁面報錯，或者結果唔符合目前設定。",
      optimizationHint: "功能用到，但體驗、效率、展示或者流程仲可以更加順手。",
      featureHint: "目前未有嘅能力，希望平台新增或者擴展支援。",
      improvementLabel: "希望點樣優化",
      improvementPlaceholder: "請講明希望減少邊啲步驟，或者介面 / 流程點樣調整",
      impactLabel: "使用頻率 / 影響場景",
      impactPlaceholder: "例如：每日匯出前都會用到，多人協作時影響更加明顯",
      scenarioLabel: "使用場景",
      scenarioPlaceholder: "請講明喺咩業務場景下需要呢個能力",
      goalLabel: "需求目標",
      goalPlaceholder: "請講明希望新增咩功能，最後要達成咩效果",
      valueLabel: "需求價值",
      valuePlaceholder: "例如：提升產能、減少人工返工、支援新嘅交付流程",
      title: "問題反映",
      placeholder: "問題反映",
      workspace: "工作台",
      close: "關閉",
      submitTitle: "提交問題反映",
      submitDesc: "BUG、優化、新需求統一入口",
      submit: "提交反映",
      saveDraft: "儲存草稿",
      draftSaved: "草稿已儲存",
      draftSaveFailed: "草稿儲存失敗，請稍後再試",
      draftEmpty: "請至少填寫一項內容先可以儲存草稿",
      draftTitle: "{type}反映：{title}",
      draftStatus: "草稿",
      continueEdit: "繼續編輯",
      deleteDraft: "刪除草稿",
      submitting: "提交緊...",
      submitSuccess: "問題反映已提交",
      submitFailed: "提交失敗，請稍後再試",
      uploadFailed: "附件上載失敗，請重新試下",
      uploading: "上載緊...",
      uploaded: "已上載",
      removeFile: "移除檔案",
      fileCountInvalid: "最多可以上載 5 個附件",
      fileTypeInvalid: "只支援 PNG、JPG、JPEG 或 MP4 檔案",
      fileSizeInvalid: "檔案大小要大過 0，而且唔可以超過 200 MB",
      myFeedback: "我嘅反映",
      empty: "暫無數據",
      listHint: "查看已提交問題反映嘅回覆、狀態變更同通知。",
      view: "查看",
      platformReply: "平台回覆",
      delete: "刪除",
      formTitle: "反映問題",
      formHint: "選擇類型後填寫必要資料，提交後會進入後台工單。",
      typeLabel: "問題類型",
      typeBug: "BUG",
      typeOptimization: "優化",
      typeFeature: "新需求",
      titleLabel: "問題標題",
      titlePlaceholder: "一句話講清楚遇到嘅問題",
      requiredField: "請輸入{field}",
      moduleLabel: "所屬模組",
      moduleCanvas: "漫畫畫布",
      moduleWorkflow: "工作流",
      moduleAccount: "帳戶中心",
      descriptionLabel: "問題描述",
      descriptionPlaceholder: "請描述發生咗咩事，同埋出現喺邊個項目或作品入面",
      stepsLabel: "重現步驟",
      stepsPlaceholder: "例如：進入項目、選擇鏡頭、點擊生成，再檢查結果",
      upload: "上載截圖 / 錄屏",
      uploadHint: "支援 PNG、JPG、MP4。",
      detailTitle: "反映詳情",
      readonly: "只讀資料，不可修改",
      ticket: "工單號",
      notProvided: "未填寫",
      deleteTitle: "刪除工單",
      deleteMessage: "係咪要刪除呢張工單？",
      cancel: "取消",
      confirmDelete: "確認刪除",
      deleteSuccess: "問題反映已刪除",
      deleteFailed: "刪除問題反映失敗，請稍後再試",
      replyTitle: "平台回覆",
      replyContent: "回覆內容",
      attachments: "附件",
      attachmentCount: "{count} 個檔案",
      download: "下載",
      gotIt: "我知道喇",
      statusProcessing: "處理中",
      statusResolved: "已處理",
      justNow: "啱啱",
    },
    // 登入成功後未讀公告彈窗
    announcementDialog: {
      badge: "更新通知",
      fallbackTitle: "系統更新",
      publishedAt: "發佈時間 {time}",
      confirm: "我知啦",
      closeAria: "關閉更新通知",
    },
    // 更新日誌全屏彈窗（分頁查詢全部公告）
    changelog: {
      title: "更新日誌",
      close: "關閉",
      empty: "暫無更新記錄",
      emptyTip: "有新版本發佈時，更新內容會顯示喺度",
      loading: "加載中...",
      loadFailed: "更新日誌加載失敗，請稍後再試",
      retry: "重試",
      fallbackTitle: "系統更新",
    },
    pointsPopover: {
      managePoints: "積分管理",
      currentPoints: "目前積分",
      teamTotalPoints: "可分配積分",
      allocatePoints: "分配積分",
      rechargePoints: "增值積分",
      subscriptionPoints: "訂閱積分",
      buyMembership: "會員訂閱",
      buyPoints: "積分增值",
      viewUsage: "查看使用情況",
    },
    memberCenter: {
      editProfile: "編輯個人資料",
      editProfileHint: "只可以修改姓名",
      closeEditor: "關閉個人資料編輯",
      name: "姓名",
      namePlaceholder: "請輸入姓名",
      phone: "手機號碼",
      accountLevel: "帳號層級",
      role: "角色",
      parentAdmin: "所屬管理員",
      monthlyPoints: "每月積分",
      monthlyPointsEnterpriseHint: "（超級管理員帳戶）",
      showPhone: "顯示",
      hidePhone: "隱藏",
      readonlyHint: "以上帳號權限資料不可修改",
      personalAccount: "個人帳號",
      enterpriseMainAccount: "企業主帳號",
      enterpriseSubAccount: "企業子帳號",
      saveSuccess: "個人資料修改成功",
      addSeats: "新增席位",
      addSeatsHint:
        "新增席位功能用嚟為而家嘅團隊訂閱增加可用成員名額，新增席位即時生效，並且同原本團隊訂閱保持相同到期時間。",
      addSeatsPointsNotice:
        "本月增席發放嘅積分可以延後使用，未使用部分會喺 {date} 重設。",
      addSeatsPointsHelp:
        "例子說明\n\n" +
        "假設你嘅套餐每月發放 20,000 積分，8 月 10 日增加 1 個席位，\n系統即時補發 5,000 積分。\n\n" +
        "情況一：週期內未用完\n9 月 10 日刷新時，帳戶仲剩 6,000 積分\n→ 新週期收到 20,000 + 5,000 = 25,000 積分\n→ 10 月 10 日刷新時，恢復為 20,000 積分，增席積分唔再延期\n\n" +
        "情況二：週期內只剩一部分\n9 月 10 日刷新時，帳戶只剩 3,000 積分\n→ 可延期額度按剩餘嘅 3,000 計算，新週期收到 23,000 積分\n\n" +
        "情況三：週期內已用完\n9 月 10 日刷新時，帳戶餘額係 0\n→ 冇可延期嘅積分，新週期收到 20,000 積分",
      addSeatsPointsHelpAria: "查看增席積分延期例子",
      subscriptionPointsResetNote: "{date} 23:59:59 清零 · 優先使用",
    },
    recharge: {
      bonusRate: "（包括贈送 {rate}%）",
    },
    accountCenter: {
      productName: "AI影片創作",
      nav: {
        account: "帳戶",
        usage: "使用情況",
        rechargeRecords: "增值記錄",
      },
      accountInfo: "帳戶資訊",
      registeredAt: "註冊時間",
      account: "帳號",
      points: "積分",
      totalPoints: "積分",
      serialNumber: "序號",
      columns: {
        details: "詳情",
        time: "時間",
        pointsChange: "積分變更",
        model: "模型",
        resolution: "解像度",
        duration: "時長",
        orderNo: "訂單號",
        orderAmount: "訂單金額",
        orderPoints: "訂單積分",
        bonusPoints: "贈送積分",
        paymentMethod: "付款方式",
        orderTime: "落單時間",
      },
    },
    messages: {
      comingSoon: "即將上線，敬請期待",
    },
  },
  landing: {
    navLabel: "首頁導覽",
    home: "首頁",
    productServices: "產品服務",
    aboutUs: "關於我哋",
    login: "登入",
    startCreating: "開始創作",
    authPanel: {
      browserUnsupported: "你嘅瀏覽器唔支援 HTML5 video 標籤。",
      closePanel: "關閉登入面板",
      heroTitleManshu: "漫樞，令好故事畀人睇見",
      heroTitleManjing: "漫鏡，令好故事畀人睇見",
      heroPrompt: "一鍵生成角色、分鏡和影片畫面",
      slogan: "令每一個好故事，都可以给世界看見",
      titles: {
        welcomeManshu: "歡迎嚟到漫樞",
        welcomeManjing: "歡迎嚟到漫鏡",
        register: "註冊帳號",
        bindPhone: "綁定手機號碼",
        password: "搵返密碼",
      },
      tabs: {
        account: "帳號密碼登入",
        phone: "驗證碼登入",
      },
      accountTypes: {
        enterprise: "企業",
        personal: "個人",
      },
      placeholders: {
        username: "請輸入用戶名",
        password: "請輸入密碼",
        phone: "請輸入手機號碼",
        code: "請輸入驗證碼",
        companyName: "請輸入企業名稱",
        invitation: "請輸入邀請碼（選填）",
        newPassword: "請輸入新密碼",
        confirmPassword: "請再次輸入新密碼",
      },
      actions: {
        login: "登入",
        register: "註冊",
        getCode: "取得驗證碼",
        retryAfter: "{seconds}s 後重試",
        showPassword: "顯示",
        hidePassword: "隱藏",
        resetPassword: "確認重設",
        bindAndLogin: "綁定並登入",
      },
      links: {
        forgotPassword: "忘記密碼？",
        noAccount: "仲未有帳號？",
        registerNow: "立即註冊",
        hasAccount: "已有帳號？",
        loginNow: "立即登入",
        backToLogin: "返回登入",
        backToLoginWithArrow: "←返回登入",
      },
      agreement: {
        prefix: "登入即代表同意",
        terms: "《用戶協議》",
        and: "同",
        privacy: "《私隱政策》",
      },
      bindPhone: {
        tip: "為保障帳號安全，請綁定手機號碼",
        currentAccount: "目前帳號",
        desc: "尚未綁定手機號碼。綁定後可使用手機號碼快捷登入，並保障帳號安全。",
        notice: "為保障帳號安全，綁定手機號碼後先可以使用平台",
      },
      messages: {
        inviteLoadFailed: "取得邀請碼失敗",
        enterPhoneFirst: "請先輸入手機號碼",
        enterPhone: "請輸入手機號碼",
        invalidPhone: "請輸入正確嘅手機號碼",
        codeSent: "驗證碼已發送",
        enterCode: "請輸入驗證碼",
        enterNewPassword: "請輸入新密碼",
        enterConfirmPassword: "請再次輸入新密碼",
        passwordMismatch: "兩次輸入嘅新密碼唔一致",
        passwordResetSuccess: "密碼重設成功",
        passwordResetFailed: "密碼重設失敗",
        loginSuccess: "登入成功",
        registerSuccess: "註冊成功",
        invalidLoginState: "登入狀態異常，請重新登入",
        bindPhoneFailed: "綁定手機號碼失敗",
        enterInvitation: "請輸入邀請碼",
        enterCompanyName: "請輸入企業名稱",
        enterAccount: "請輸入帳號",
        enterPassword: "請輸入密碼",
      },
    },
    teamInvite: {
      close: "關閉團隊邀請註冊彈窗",
      loading: "正在載入邀請資料...",
      retry: "重試",
      loadFailed: "邀請連結無效或已過期，請聯絡邀請人重新取得",
      codeFailed: "驗證碼發送失敗，請稍後再試",
      registerFailed: "註冊失敗，請稍後再試",
      title: "{name}團隊嘅邀請連結",
      titleFallback: "團隊邀請連結",
      subtitle: "完成註冊後即可一鍵加入團隊",
      passwordMin: "密碼至少要有 6 位",
      agreementPrefix: "註冊即代表同意",
      details: {
        teamName: "企業名稱",
        accountLevel: "帳號層級",
        businessRole: "業務角色",
        parentAdmin: "所屬管理員",
      },
      fields: {
        phone: "手機號碼",
        code: "驗證碼",
        password: "密碼",
        confirmPassword: "確認密碼",
      },
    },
    partners: {
      title: "AIGC 創意合作伙伴",
      desc: "匯聚全球 AIGC 先鋒創作者，用 AI 賦能創意表達，打破傳統製作邊界。",
      featuredCreator: "今期推薦創作者",
      featuredWork: "精選作品",
      featuredWorkAlt: "{name}精選作品",
      creatorAria: "查看{name}嘅創作者資料",
      items: {
        0: {
          name: "泫九",
          headline:
            "第八屆初心榜 AIGC 年度傑出十大人物（中國電視劇製作產業協會、首都視聽產業協會）",
          bio: "入圍 IM 兩岸青年影展（福建省電影局、福建省廣播電視局、福建省廣播影視集團）\n第六屆馬欄山盃-金獎（芒果衛視主辦）\nParallel Worlds-金獎（B 站主辦）\n第三屆上海國際 AIGC-二等獎（上海市嘉定南翔人民政府主辦）\nWANMUSE+ 全球創作大賽第一季-最佳視覺獎（阿里主辦）",
        },
        1: {
          name: "寧同學",
          headline:
            "視覺設計師 · AIGC 創作者\n「大眼鎮」系列作品作者 · 即夢 · 小雲雀 · 可靈優創",
          bio: "· 2026 ADC 105th Annual Awards BRONZE WINNER（銅獎）\n· 「李白在安陸」詩詞短視頻創作大賽 視頻組 一等獎\n· 佛堂十月十 AIGC 全球短視頻創作大賽 一等獎\n· 2025 Team Championship Prompt Battle Grold 金獎\n· 2025 AI視界·影像中國 短視頻創作大賽 銀獎\n· 第二屆全球 AI 視覺創意大賽瓦卡獎 VACAT 圖像組 優秀獎",
        },
        2: {
          name: "泫寬",
          headline:
            "AIGC 廣告導演 · 故事接龍 MCN 簽約作者 · AI+3D 打印農場合伙人",
          bio: "PixVerse 超創 · 豆包 · 即夢成長計劃 · 元極AI 等簽約藝術家\n工信部 AIGC 專業級 · 前上海電視台紀實人文頻道責編 · 上影 AIGC 講師\n\n合作品牌：上汽智己、豆包、中國人壽、比亞迪、京東、吉利、洋河、國台等",
        },
        3: {
          name: "NONOPark",
          headline:
            "視覺導演 · AI 視頻創作 · NONO Park（泫宗 泫一個） · 易點天下深度合作 · 片頭宣傳片 · 電商產品視頻",
          bio: "大家好，我係泫宗 泫一個，網名係「NONO Park」，一名專注 AI 視頻創作嘅視覺導演同內容創作者。我致力將前沿 AI 技術同視覺藝術深度融合，探索視頻內容生產嘅全新邊界。\n\n喺 AI 視覺創作領域，我有紮實嘅實戰經驗同商業落地能力。之前我帶作品參加蘇州科技園舉辦嘅「AI無界·科創賦能-AI視覺創作」大賽，並成功斬獲入圍獎。呢段經歷唔單止係對我 AI 創作能力嘅認可，亦令我對科技賦能視覺藝術有更深理解。\n\n喺商業合作方面，我目前同出海營銷頭部企業「易點天下」保持深度綁定合作。合作期間，我主要負責 AI 短視頻嘅跑通測試、規模化製作同高質量交付，累積咗豐富嘅商業級項目管理經驗，可以精準把控由前期概念測試到最終成片交付嘅每一個環節。\n\n喺內容創作上，我尤其擅長片頭宣傳片同電商產品視頻宣傳嘅 AI 生成與製作。熟練運用各類 AI 視頻工具，唔單可以大幅提升製作效率，仲可以為品牌同產品帶來具視覺衝擊力同科技感嘅呈現效果，助力商業轉化。\n\n我一直相信 AI 係創作者最強大嘅畫筆。期待未來同更多優秀團隊同伙伴交流合作，一齊探索 AI 視頻創作嘅無限可能！",
        },
        4: {
          name: "伊達",
          headline:
            "個人 AIGC 創作者 · 工信部認證 AIGC 高級藝術家 · 多平台超創",
          bio: "前國有銀行總行級內訓師\n\n· ISMA2025 三等獎\n· 百度 AI 追熱季 S1 賽季 商業創意獎\n· 國內多個平台賽事獎項",
        },
        5: {
          name: "MK",
          headline:
            "AIGC 創作者 · 即夢 AI 成長計劃 · 抖音簽約創作者\nFlova.ai 新銳創作者",
          bio: "深耕 AIGC 視覺創作領域，擅長運用各類 AI 工具做視覺表達同內容生產。\n\n· 海合安首屆 AIGC 創意挑戰大賽 藍色星球創新獎\n· 2024 世界人工智能大會 WAIC 美好奇妙世界 AI 繪畫大賽 一等獎",
        },
        6: {
          name: "泫三十",
          headline: "國內 AIGC 賽道領軍人物 · 海螺AI/拍我AI超級創作者",
          bio: "擁有二十多年影視全流程經驗，歷任技術總監、執行導演、總導演、總製片等職位，主導過百項傳統影視項目。亦係多平台簽約作家，著書十多部，累計近千萬字，作品多次登頂榜單；兼具 AI 音樂創作資質；參編國家「十四五」規劃教材。曾斬獲北京電影學院、大灣區電影展、矽谷 AI 電影節、網易、騰訊等國內外重磅 AIGC 與影視獎項，技術、創作、製片能力突出。",
        },
        7: {
          name: "泫宗 2046",
          headline: "一名普通剪輯師",
          bio: "獲獎：我ai北京榮獲優秀獎，作品曾登上北京日報。溫州謝靈運 ai 比賽榮獲優秀獎",
        },
        8: {
          name: "泫宗尼古貓",
          headline:
            "尼古貓【多平台優質創作者、長治Ai紅色題材金獎、冷湖科幻賽道銀獎、可靈X閱文十周年角逐IP之光大賽三等獎】",
          bio: "",
        },
        9: {
          name: "泫宗 百寶閣",
          headline: "佛系 AI 玩家 · 多項 AIGC 大賽前三",
          bio: "一位佛系 AI 玩家，曾喺以下大賽都攞到至少前三名：中國台灣光復80周年暨祖國統一 AIGC 短片創作大賽、「小馬過河盃」AIGC 寓言創作大賽、廊橋 AI 出海視頻創作大賽、「楠溪創享家」AI 視頻創作大賽、「益路同行」中國公益出海 AI 動畫短片大賽等一系列大賽，小賽就唔多講喇",
        },
        10: {
          name: "不近視的貓",
          headline:
            "萬粉公眾號博主 · 海螺AI超創 · Flova.ai 超創 · Vidu藝術家 · 可靈優質創作者",
          bio: "微博 AI 視頻創作大賽次元賽道最佳作品；百度春節創作賽銅獎；作品曾喺第一屆 Redstar 計劃大會「優秀 AI 影視作品」展映。",
        },
        11: {
          name: "泫宗 忘記",
          headline:
            "可靈優秀創作者；和平精英簽約 AIGC 作者；剪映 Ai 創意視頻第一期優質創作者",
          bio: "",
        },
        12: {
          name: "泫宗迷途",
          headline: "AIGC 時代嘅傳媒創作者 · 技術為筆 · 創意為核",
          bio: "探索視頻內容嘅全新表達邊界，服務政務、媒體、商業三大賽道，合作浙江省衛健委、浙江省紀委、河南廣電、杭州日報、中國電信、吉利汽車等數十家政企，打造多項創新 AI 視頻精品。作品曾榮獲伊利、柒牌、杭州日報等平台 AI 視頻大賽獎項。",
        },
        13: {
          name: "梁米啦",
          headline: "AIGC 導演/數碼藝術家/編劇/心理諮詢師",
          bio: "故事接龍 MCN 簽約作者｜LibTV、漫樞等平台超級創作者\n\n2022 年進入 AIGC 創作領域，作品覆蓋劇情短片、科幻視效、奇幻兒童冒險、治癒 MV、TVC 廣告、文旅宣傳、短劇、IP 二創及短劇視覺開發等多個領域。\n\n2022 年首批入局 AIGC 嘅探索者，曾獲重慶春晚 AIGC 創意大賽一等獎、乘風2026AIMV優秀獎、可靈AI創意MV挑戰賽二等獎、VGS世界AI視頻大賽銅獎等幾十項獎項/入圍。影視 IP 二創作品曾獲相關主創評論互動。",
        },
        14: {
          name: "泫宗崔一下",
          headline:
            "大型天然氣集團首席 AI 設計師｜工信部 AI 視覺設計師（高級）",
          bio: "現任大型天然氣集團首席 AI 設計師，工信部 AI 視覺設計師（高級）。AI 視頻愛好者。",
        },
        15: {
          name: "泫宗水之心",
          headline: "心水映畫創始人 · AI 與影視內容創新者",
          bio: "心水映畫（水之心）係專注 AIGC 視覺敘事嘅專業創作品牌，創始人朱欽兼具中科大紮實理工功底、完整影視製作經驗，曾任職芒果 TV、世界五百強企業，擁有新媒體全鏈路創業實戰經歷，打通技術同內容創作壁壘。\n\n品牌主營 AI 短劇、品牌 AI 廣告、AI 電影、文旅宣傳片，服務國企、醫療、國際品牌等多領域客戶，產出多部全網播放量破億嘅爆款內容，形成成熟可複製嘅 AI 內容工業化體系。\n\n團隊斬獲馬欄山 AI 大賽金獎、全球數字經濟創新大賽新星獎等多項權威榮譽，融合東方水墨美學同前沿 AI 技術，以智能化手段賦能影像創作，持續探索數碼視覺新表達。",
        },
      },
    },
    product: {
      heroImageAlt: "AIGC漫劇創作管理平台",
      floatTags: {
        data: "全球內容大數據",
        insight: "爆款洞察模型",
        script: "劇本AI創作",
        asset: "資產導演模型",
        video: "一鍵成片系統",
      },
      eyebrow: "產品服務",
      titlePrefix: "AIGC漫劇創作",
      titleAccent: "管理平台",
      subtitle: "由劇本到成片，一站式 AI 漫劇創作與管理",
      cta: "立即體驗",
      ctaHint: "註冊即可免費試用核心功能",
      capabilities: "六大核心能力",
      detail: "查看詳情",
      services: {
        data: {
          title: "AI爆款漫短劇大數據平台",
          tagline: "4.2萬億賽道，先發制勝",
          desc: "全球多模態大數據引擎、爆款預測同趨勢捕捉，由選題洞察到投產預判，幫創作者鎖定下一部爆款。",
        },
        production: {
          title: "AI影視動漫製作管理平台",
          tagline: "劇本到成片，24 小時極速交付",
          desc: "AI 解析劇本自動生成分鏡，角色資產全劇復用，文生圖、圖生影片、分鏡切片、合成預覽全流程覆蓋。",
        },
        copyright: {
          title: "版權一站式登記平台",
          tagline: "AI 作品確權，唯快不破",
          desc: "打通 AI 劇本版權登記難題，每一部作品生成即確權，構建海量 IP 資產嘅長期競爭優勢。",
        },
        filing: {
          title: "漫劇/短劇一鍵備案平台",
          tagline: "稀缺牌照，獨家通道，合規無憂",
          desc: "網絡視聽許可證同短劇備案能力接入平台，一鍵完成合規備案，令創作者只需專注創作。",
        },
        distribution: {
          title: "全球多平台發行",
          tagline: "一鍵分發 100+ 國家",
          desc: "多語種 AI 自動翻譯配音同海外平台矩陣覆蓋，由本地到全球，一次製作、一鍵分發。",
        },
        commercialization: {
          title: "IP衍生商業化",
          tagline: "由內容到資產，釋放長尾價值",
          desc: "角色 IP 孵化、虛擬形象授權、消費品開發同全球版權交易，搭建內容變現閉環。",
        },
      },
    },
    about: {
      title: "關於我哋",
      vision: "願景：令每一個好故事，都可以给世界看見。",
      mission: "使命：用 AI 重塑內容工業化，賦能全球創作者。",
      contact: "聯絡我哋",
      customerServiceWechat: "客服微信",
      customerServiceWechatQr: "客服微信二維碼",
      follow: "關注我哋",
      socialQrAlt: "{name}二維碼",
      companyAddress:
        "合肥漫域巔峰科技有限公司 ｜ 地址：安徽省合肥市望江西路535號雲掌大廈B座2層",
      social: {
        douyin: "抖音",
        videoAccount: "視頻號",
        wechatOfficial: "公眾號",
        xiaohongshu: "小紅書",
        weibo: "微博",
        bilibili: "嗶哩嗶哩",
      },
      paragraphs: [
        "漫樞平台由合肥漫域巔峰科技有限公司精心打造，構建全球 AI 影視動漫工業化生態系統，打造全球領先嘅 AI 內容「快時尚」引擎。公司由中國頂級影視廣告營銷大數據技術專家、國內超一流動漫製作團隊以及國內一流資本運作團隊聯合創辦。",
        "漫樞生態體系包括：全球內容大數據 SAAS 平台、AI創意大腦中心 SAAS 平台、漫短劇製作管理 SAAS 平台、爆款內容預測模型、爆款內容工廠、漫短劇商業化平台、產教融合體系、內容版權登記平台、基於網絡視聽許可證牌照嘅播出&備案管理平台、全球內容出海同發行等。",
        "漫樞重點解決創作者點樣做得快、做得好、賣得出、賺得多嘅全鏈路問題。",
        "公司主營八大業務矩陣，彼此串聯、相互關聯，SAAS 工具三個版本覆蓋全行業創作者同潛在創作者群體，以基於大數據嘅影視動漫製作工具為核心，結合影視、動漫、廣告營銷同學校教育等公司具備豐富資源嘅領域，推動主營業務發展同裂變。",
        "公司核心團隊參與國家「十五五」12本 AIGC 系列教材編制，係唯一參與教材編制嘅企業單位。憑住原創 ZARA 內容工廠模式，打造海量原創 IP 嘅爆款內容同全球發行，再透過集團版權登記資質同網絡視聽許可證牌照，形成天然競爭壁壘，建立獨有商業模式同差異化競爭。",
        "漫樞透過自主研發核心技術打造三大影視營銷模型：Manyutop-Mind（文本模型）、Manyutop-Vision（圖像模型）、Manyutop-Motion（影片模型），喺通用大模型基礎上，通過微調、領域知識庫建立同產業 Skills 運用，大幅度提升垂直行業能力，為之後市場爆發打好基礎。",
        "漫樞客戶群體包括：漫短劇公司、影視公司、創作者、MCN公司、廣告營銷公司、媒體、品牌方等。",
      ],
    },
  },
  auth: {
    loginExpired: "登入狀態已失效，請重新登入",
    otherDeviceLogin: "而家個帳號喺其他裝置登入，請留意帳號安全。",
    accountFrozen: "帳號已經凍結咗，請聯絡管理員。",
  },
  route: {
    home: "首頁",
    scriptPage: "劇本頁",
    storyboard: "分鏡編輯",
    scriptPreview: "分鏡預覽",
    copywritingCreation: "劇本創作",
    detectionResult: "偵測結果頁",
    myProject: "我的項目",
    projectManagement: "片段管理",
    hotRanking: "熱門榜單",
    statisticalDimension: "統計維度",
    visionCanvas: "無限畫布",
    visionCanvasEditor: "無限畫布編輯",
    projectGroupWorkbench: "項目組工作台",
    roleManagement: "角色管理",
    sceneManagement: "場景管理",
    propManagement: "道具管理",
    login: "登入",
    projectGroupInvite: "項目組邀請",
    userManagement: "用戶管理",
    teamManagement: "團隊管理",
    invoice: "訂單管理",
  },
  invoiceCenter: {
    view: "查看",
    reissue: "重開",
    resend: "重發到電郵",
    resendSuccess: "發票電郵已重發",
    resendFailed: "發票電郵重發失敗，請稍後再試",
    resendConfirm: {
      title: "重發到電郵",
      message: "確定將呢張發票重新發送到收票電郵嗎？",
    },
    reissueDialog: {
      title: "重新開票",
      submit: "確認重開",
      loadFailed: "原發票資料載入失敗，請稍後再試",
      submitSuccess: "重開申請已提交",
      submitFailed: "重開申請提交失敗，請稍後再試",
    },
    detail: {
      title: "發票詳情",
      invoiceInfo: "開票資料",
      orderInfo: "訂單資料",
      purchaserType: "購買方類型",
      taxpayerNumber: "納稅人識別號",
      invoiceCode: "發票代碼",
      invoiceNumber: "發票號碼",
      allElectronicInvoiceNumber: "全電發票號碼",
      failureReason: "失敗原因",
      invoiceFile: "發票檔案",
      download: "下載發票",
      orderAmount: "訂單開票金額",
      emptyOrders: "暫無關聯訂單",
      close: "關閉",
      loadFailed: "發票詳情載入失敗，請稍後再試",
    },
    title: "訂單管理",
    subtitle: "查看可開票訂單同歷史開票記錄",
    tabs: {
      paidOrders: "已付款訂單",
      history: "開票歷史",
    },
    refresh: "重新整理",
    loading: "載入中",
    emptyOrders: "暫無已付款訂單",
    emptyHistory: "暫無開票歷史",
    loadFailed: "發票資料載入失敗，請稍後再試",
    columns: {
      orderNo: "訂單號",
      payDescription: "訂單描述",
      payTime: "付款時間",
      paidAmount: "付款金額",
      invoiceAmount: "開票金額",
      orderStatus: "開票狀態",
      applyNo: "開票申請號",
      purchaserName: "發票抬頭",
      invoiceStatus: "發票狀態",
      createTime: "申請時間",
      issueTime: "開具時間",
      actions: "操作",
    },
    apply: "開發票",
    unavailable: "目前訂單唔可以開票",
    submitSuccess: "開票申請已提交",
    submitFailed: "開票申請提交失敗，請稍後再試",
    dialog: {
      title: "申請開發票",
      orderNo: "訂單號",
      amount: "開票金額",
      purchaserType: "購買方類型",
      personal: "個人",
      enterprise: "企業",
      category: "發票種類",
      normalInvoice: "電子普通發票",
      specialInvoice: "電子專用發票",
      purchaserName: "發票抬頭",
      purchaserNamePlaceholder: "請輸入個人姓名或企業名稱",
      taxpayerNumber: "納稅人識別號（企業必填）",
      taxpayerNumberPlaceholder: "請輸入企業納稅人識別號",
      address: "購買方地址（選填）",
      phone: "購買方電話（選填）",
      bank: "開戶銀行（選填）",
      bankAccount: "銀行帳號（選填）",
      mobile: "接收手機號（選填）",
      mobilePlaceholder: "用嚟接收電子發票通知",
      email: "接收電郵（選填）",
      emailPlaceholder: "用嚟接收電子發票通知",
      cancel: "取消",
      submit: "提交申請",
    },
    validation: {
      purchaserType: "請選擇購買方類型",
      category: "請選擇發票種類",
      purchaserName: "請輸入發票抬頭",
      taxpayerNumber: "請輸入納稅人識別號",
      email: "請輸入正確嘅電郵地址",
    },
    status: {
      UNINVOICED: "未開票",
      SUBMITTING: "待提交開票申請",
      ISSUING: "開票中",
      ISSUED: "已開票",
      RED_PROCESSING: "紅沖處理中",
      ISSUE_FAILED: "開票失敗",
      RED_REQUESTED: "紅沖中",
      RED_ISSUED: "已紅沖",
      RED_FAILED: "紅沖失敗",
      REISSUE_WAITING_RED: "等待原票紅沖",
    },
  },
  workflow: {
    steps: {
      script: "劇本",
      assets: "素材",
      storyboard: "分鏡影片",
      compose: "一鍵成片",
    },
    actions: {
      next: "下一步",
      parseScript: "解析劇本",
      autoStoryboard: "自動拆分鏡",
      preview: "預覽",
    },
    script: {
      projectName: "項目名稱",
      episode: "片段",
      aspectRatio: "比例選擇",
      ratio: "比例",
      style: "風格選擇",
      myScript: "我嘅劇本",
      placeholder: "輸入而家片段嘅劇本內容（非必填）",
      defaultSettingsTip:
        "所選參數會作為之後創作的預設值，亦可以修改。你可以輸入劇本自動提取素材同分鏡，或者不輸入劇本，按下一步手動建立素材同分鏡。",
      assetNextTip: "按下一步進入分鏡影片頁面，可以建立分鏡圖片同影片。",
      assetAutoTip:
        "撳自動拆分鏡，系統會根據劇本同素材自動生成分鏡圖片同影片。",
    },
    scriptPage: {
      previewImage: "預覽圖片",
      favorite: "收藏",
      favoriteImage: "收藏圖片",
      selectImage: "選擇圖片",
      selectVideo: "選擇影片",
      records: "記錄",
      materials: "素材",
      favorited: "已收藏",
      selected: "已選擇",
      uploadImage: "上載圖片",
      dragFile: "將檔案拖到呢度，或者",
      clickUpload: "撳呢度上載",
      imageAlt: "圖片 {id}",
      videoAlt: "影片 {id}",
      imageGenerationFailed: "圖片生成失敗",
      videoGenerationFailed: "影片生成失敗",
      generating: "生成中...",
      imageRecordsHint:
        "提示：撳縮圖可以預覽大圖，撳星號可以收藏圖片，撳剔號可以選擇圖片",
      videoRecordsHint: "提示：撳縮圖可以預覽影片，撳剔號可以選擇影片",
      materialsHint: "提示：撳素材可以選中，撳刪除可以移除素材",
      audioUnsupported: "你嘅瀏覽器唔支援 audio 標籤",
      addImage: "加入圖片",
      imageFormatHint: "支援 PNG、JPG、JPEG、BMP，最大 10MB",
      outputImageCount: "輸出圖片數量",
      outputVideoCount: "輸出影片數量",
      generateImage: "生成圖片",
      generateVideo: "生成影片",
      pointsCost: "消耗 {count} 積分",
      materialImage: "素材圖片",
      audioMaterial: "音訊素材",
      noPreview: "暫時冇預覽",
      draftVideo: "草稿影片",
      imageSettings: "生成圖片參數設定",
      videoSettings: "生成影片參數設定",
      imageCount: "圖片數量",
      videoCount: "影片數量",
      startGenerate: "開始生成",
      noRecordsOrMaterials: "暫時冇記錄／素材，你可以試下生成或者上載",
      batchGenerateMedia: "批量生成{media}",
      confirmBatchGenerate: "係咪批量生成{media}？",
      memberSettings: "成員設定",
      username: "用戶名",
      usernamePlaceholder: "請輸入用戶名",
      projectMembers: "項目成員：{count}人",
      assignImageAndVideo: "係咪同時分配圖片同影片分鏡",
      role: "角色",
      rejectData: "打回資料",
      rejectReason: "打回原因",
      rejectReasonPlaceholder: "請輸入打回原因，Ctrl + V 貼上圖片",
      uploading: "上載緊...",
      custom: "自訂",
      dialogueTypes: {
        lipSync: "包含口型",
        narration: "旁白",
        innerMonologue: "內心獨白",
      },
      shotSizes: {
        0: "大遠景",
        1: "遠景",
        2: "全景",
        3: "中景",
        4: "中近景",
        5: "近景",
        6: "大特寫",
      },
      pointsFailed: "取得{media}消耗積分失敗",
      imageMax5MB: "圖片唔可以超過 5MB",
      approveConfirm: "係咪通過目前資料？",
      approveTitle: "確認通過",
      selectAssignee: "請選擇要分配嘅成員",
      assignmentSuccess: "分配成功",
      selectStoryboardsToAssign: "請選擇要分配嘅分鏡",
      imageRequestFailed: "圖片生成請求失敗",
      requestFailed: "請求失敗 😿",
      addLastFrame: "請加入尾幀圖片",
      operationFailed: "操作失敗",
      voiceMissingTitle: "未設定聲音",
      voiceMissingMessage:
        "提示：仲有人物未選擇聲音，分鏡提示詞唔會生成該人物嘅音訊引用，需要你手動引用人物聲音，係咪繼續拆分鏡？",
      continueStoryboardSplit: "繼續拆分鏡",
      taskTimeout: "任務處理逾時，請稍後重新整理頁面睇進度",
      storyboardGenerationFailed: "分鏡生成失敗",
      scriptParsingFailed: "劇本解析失敗",
      supportedMaterialTypesOnly: "只支援上載音訊、影片或者圖片",
      uploadFailedWithReason: "上載失敗：{reason}",
      serverError: "伺服器異常",
      imageUploadFailed: "圖片上載失敗",
      imageUploadingWait: "圖片上載緊，請等上載成功之後再儲存",
      imageMustUploadBeforeSave: "圖片上載成功之後先可以儲存",
    },
    storyboard: {
      images: "分鏡圖片",
      videos: "分鏡影片",
      imageTab: "圖片",
      videoTab: "影片",
      item: "分鏡",
      itemName: "分鏡 {label}",
      list: "分鏡列表",
      add: "新增分鏡",
      batchDownload: "批量下載",
      composeTip:
        "預覽可以快速睇分鏡影片嘅連貫效果；一鍵成片會將已有嘅分鏡影片自動剪輯成完整影片。",
    },
    storyboardList: {
      expandPrompt: "展開",
      collapsePrompt: "收起",
      noPrompt: "暫無提示詞",
      editStoryboard: "編輯分鏡",
      splitStoryboard: "拆分鏡",
      more: "更多",
      waitingVideo: "等待影片生成",
      generatingProgress: "生成中 {current}/{total}",
      labels: {
        model: "模型",
        shotSize: "景別",
        dialogue: "對白",
        characters: "涉及角色",
        ratio: "比例",
        voice: "聲線",
        scenes: "涉及場景",
        props: "涉及道具",
        operator: "操作人",
        reviewer: "審核人",
        cameraMovement: "鏡頭運動",
        lipSync: "口型同步",
        videoMode: "生成影片方式",
      },
      yes: "係",
      no: "唔係",
      videoModes: {
        prompt: "全能參考",
        firstFrame: "首幀",
        firstLast: "首尾幀",
      },
      media: {
        image: "圖片",
        video: "影片",
        audio: "音頻",
      },
      submitReview: "提交審核",
      approve: "通過",
      reject: "打回",
      insertBefore: "喺目前鏡頭之前插入",
      insertAfter: "喺目前鏡頭之後插入",
      messages: {
        selectStoryboard: "請選擇分鏡",
        selectStyle: "請選擇風格",
        batchConfirm:
          "批量生成會統一使用目前選擇嘅模式同模型，並覆蓋<br>已編輯嘅分鏡內容，係咪繼續？",
        batchStarted: "批量生成已開始，正在處理中...",
        batchRequestFailed: "批量生成請求失敗",
        noPreviewVideos: "暫時冇可預覽嘅分鏡影片，請先生成分鏡影片",
        previewFailed: "載入預覽失敗",
        noComposeVideos: "暫時冇可成片嘅分鏡影片，請先生成分鏡影片",
        composeFailed: "一鍵成片失敗",
        reviewTitle: "確認提交審核？",
        reviewConfirm:
          "提交之後，目前資料會進入待審核狀態，管理員通過或打回之前都唔可以再編輯。",
        downloadFailed: "下載失敗",
        deleteConfirm: "確定刪除呢個分鏡？",
        deleteMediaConfirm: "確定刪除呢個{media}？",
        added: "新增成功",
        deleted: "刪除成功",
      },
    },
    batchGenerate: {
      close: "關閉",
      selectModel: "選擇模型",
      selectVersion: "選擇版本",
      resolution: "解像度",
      style: "風格",
      ratio: "比例",
      background: "背景",
      backgroundAuto: "自動",
      backgroundOpaque: "保留背景",
      backgroundTransparent: "透明背景",
      duration: "時長",
      noModels: "暫時冇可選模型",
      noVersions: "暫時冇可選版本",
      noResolutions: "暫時冇可選解像度",
      noStyles: "暫時冇可選風格",
      noRatios: "暫時冇可選比例",
      generate: "批量生成",
      calculating: "計算中",
      imageTitle: "批量生成分鏡圖片",
      videoTitle: "批量生成分鏡影片",
      firstFrame: "首幀",
      referenceVideo: "參考生成影片",
      all: "全部",
      pointsFailed: "取得批量生成積分失敗",
      validation: {
        model: "請選擇模型",
        version: "請選擇版本",
        resolution: "請選擇解像度",
        style: "請選擇風格",
        ratio: "請選擇比例",
        duration: "請選擇時長",
      },
    },
    previewPanel: {
      loading: "影片載入中",
      empty: "暫時冇可預覽嘅分鏡影片",
      model: "模型",
      ratio: "比例",
      quality: "解像度",
      style: "風格",
      noStyleLimit: "不限風格",
      compose: "一鍵成片",
      missingScriptParams: "缺少劇本參數",
      noVideo: "冇影片",
      storyboard: "分鏡 {id}",
      download: "下載合成影片",
      composing: "正在合成影片 {progress}%",
      loadingComposer: "正在載入合成組件",
      filename: "成片-{id}.mp4",
      downloadStarted: "開始下載合成影片",
      downloadFailed: "下載失敗",
      errors: {
        network: "網絡異常，無法連接預覽服務",
        resourceLoad: "影片資源載入失敗，可能係跨域限制或連結已失效",
        composerNetwork: "影片合成組件載入失敗，請檢查網絡後再試",
        composerRefresh: "影片合成組件載入失敗，請重新整理頁面後再試",
        apiNoResponse: "預覽服務冇回應，請檢查網絡或後端服務",
        fetchFailed: "載入預覽失敗",
        playbackFailed: "合成影片播放失敗",
      },
    },
    storyboardWorkspace: {
      storyboard: "分鏡",
      storyboardName: "分鏡 {label}",
      selectShot: "請揀一個分鏡先開始編輯",
      expand: "放大",
      collapse: "收起",
      expandList: "展開分鏡列表",
      collapseList: "收起分鏡列表",
      firstFrame: "首幀",
      lastFrame: "尾幀",
      reference: "參考",
      expandAllReferences: "展開全部",
      collapseReferences: "收起",
      select: "選擇",
      addToReferences: "加入參考素材",
      download: "下載",
      fullscreen: "全螢幕",
      draft: "草稿",
      failed: "失敗",
      notGenerated: "未有生成",
      history: "生成紀錄",
      noHistory: "暫時未有生成紀錄",
      generate: "生成",
      regenerate: "重新生成",
      generateFailed: "{media}生成失敗",
      paramsMissing: "分鏡參數缺失",
      unsavedLeaveTitle: "有未儲存嘅分鏡",
      unsavedLeaveMessage:
        "以下分鏡仲未儲存：{shots}。離開後本機草稿會被清除，係咪繼續離開？",
      confirmLeave: "繼續離開",
      continueEditing: "繼續編輯",
      roleAssetReviewTitle: "角色圖片審核提示",
      roleAssetReviewMessage:
        "偵測到引用角色綁定嘅圖片未通過人員審核，係咪繼續生成？",
      continueGenerate: "繼續生成",
      firstLastPromptReferenceInvalid:
        "提示詞入面引用嘅參考圖喺首尾幀生成模式無效，係咪繼續生成？",
      roleAssetCheckFailed: "角色圖片審核狀態檢查失敗",
      media: { image: "圖片", video: "影片", audio: "音頻" },
      /** 分鏡單檔上載限制（格式/大小/邊長/時長等） */
      fileValidate: {
        listSeparator: "、",
        lessThan: "細過",
        noMoreThan: "唔超過",
        kind: { image: "圖片", video: "影片", audio: "音頻" },
        onlyMedia: "只支援圖片、影片或音頻",
        unrecognizedFormat: "無法識別檔案格式",
        imageFormatOnly:
          "圖片格式只支援 jpeg、png、webp、bmp、tiff、gif、heic/heif",
        videoFormatOnly: "影片格式只支援 mp4、mov",
        audioFormatOnly: "音頻格式只支援 wav、mp3",
        sizeNeed: "{kind}大小需{comparator} {size}（實際大小: {actual}）",
        cannotReadImageSize: "無法讀取圖片尺寸，請檢查檔案是否損壞",
        cannotDecodeImageFormat:
          "無法解析呢張 {format} 圖片，請轉成 jpeg 或 png 後再試",
        cannotReadVideoSize: "無法讀取影片尺寸，請檢查檔案是否損壞",
        imageWidthTooSmall: "圖片寬度不足 {min} 像素，請放大或更換後重試",
        imageWidthTooLarge: "圖片寬度超過 {max} 像素，請縮小後重試",
        imageHeightTooSmall: "圖片高度不足 {min} 像素，請放大或更換後重試",
        imageHeightTooLarge: "圖片高度超過 {max} 像素，請縮小後重試",
        videoEdgeRange: "影片寬高需在 {min}–{max}px 之間",
        imageAspectRange: "圖片寬高比需在 {min}–{max} 之間",
        videoAspectRange: "影片寬高比需在 {min}–{max} 之間",
        videoPixelsRange: "影片總像素需在 {min}–{max} 之間",
        videoPixelsTooLarge:
          "而家約 {actualLabel}（{width}×{height}），超出允許範圍（約 {range}）",
        videoPixelsTooSmall:
          "而家約 {actualLabel}（{width}×{height}），低於允許範圍（約 {range}）",
        videoResolutionOnly:
          "影片解像度需在 {resolutions} 之間（當前解像度: {actual}）",
        cannotReadVideoDuration: "無法讀取影片時長，請檢查檔案是否損壞",
        cannotReadAudioDuration: "無法讀取音頻時長，請檢查檔案是否損壞",
        videoDurationRange:
          "影片時長需在 {min}–{max}s 之間（實際時長: {actual}s）",
        audioDurationRange:
          "音頻時長需在 {min}–{max}s 之間（實際時長: {actual}s）",
        cannotReadVideoFps: "無法讀取影片幀率，請檢查檔案是否損壞",
        videoFpsRange:
          "影片幀率要喺 {min} 至 {max} FPS 之間（實際幀率: {actual}）",
        untitledFile: "未命名檔案",
        fileFailedDetail: "「{fileName}」{message}",
      },
      messages: {
        noOperableRecord: "暫時未有可操作嘅生成紀錄",
        selectSuccess: "選擇成功",
        selectCancelled: "已取消選擇",
        operationFailed: "操作失敗",
        noDeletableRecord: "暫時未有可刪除嘅生成紀錄",
        deleteSuccess: "刪除成功",
        deleteFailed: "刪除失敗",
        deleteDraftFailed: "刪除草稿失敗",
        noSavableImage: "暫時未有可儲存嘅生成圖片",
        referenceLimitReached:
          "目前參考已達上限{count}個，請先刪除參考再新增",
        referenceImageModeLimitReached:
          "目前參考已達上限 {count} 張，請先刪除參考再新增",
        referenceImageLimitReached:
          "目前參考圖片已達上限{count}個，請先刪除參考再新增",
        referenceVideoLimitReached:
          "目前參考影片已達上限{count}個，請先刪除參考再新增",
        referenceAudioLimitReached:
          "目前參考音訊已達上限{count} 個，請先刪除參考再新增",
        unsupportedMedia: "只支援上載圖片、影片或音訊",
        addedToReferences: "已加入參考素材",
        addFailed: "新增失敗",
        noDownloadable: "暫時未有可下載嘅{media}",
        promptPlaceholder: "請輸入提示詞",
        referenceMaterial: "參考素材",
        uploadFailed: "上載失敗",
        paramsMissing: "分鏡參數缺失",
        imageOnlyMode: "目前模式只可以上載圖片",
        imageModeImagesOnly: "圖片模式只可以上載圖片",
        referenceBatchMax10: "單次最多上載 {count} 個檔案",
        getModelsFailed: "取得模型列表失敗",
        getModelParamsFailed: "取得模型參數失敗",
        getPointsFailed: "取得消耗積分失敗",
        selectStyle: "請選擇風格",
        addFirstLastFrames: "請加入首幀同尾幀圖片",
        addFirstFrame: "請加入首幀圖片",
        saveFailed: "儲存失敗",
        saveSuccess: "儲存成功",
        generatingInProgress: "目前分鏡生成中，請等生成完成後再試",
        generateStarted: "已開始生成",
        generateFailed: "生成失敗",
        /** 保存/生成前置校驗期間切換咗分鏡、Tab 或生成記錄，今次操作取消 */
        generateCancelledOnSwitch:
          "提交期間切換咗分鏡或生成記錄，分鏡 {label} 今次生成已取消，請返回該分鏡重新生成",
        saveCancelledOnSwitch:
          "提交期間切換咗分鏡或生成記錄，分鏡 {label} 今次儲存已取消，請返回該分鏡重新儲存",
      },
      modes: {
        reference: "全能參考",
        firstLast: "首尾幀",
        first: "首幀",
      },
      promptHint: {
        reference:
          "可以上載參考內容。提示詞 輸入「@」可以引用角色、場景、道具、素材。",
        firstFrame:
          "提示詞：上載圖片作為首幀。輸入「@」可以引用角色、場景、道具、素材。",
        firstLast:
          "上載圖片作為首／尾幀。提示詞輸入「@」可以引用角色、場景、道具、素材。",
      },
      reviewStatus: {
        legend:
          "上載參考會自動進行真人審核，綠色表示審核通過，紅色代表審核失敗，黃色表示審核緊",
      },
      config: {
        noModels: "暫時未有可用模型",
        noStyles: "暫時未有可用風格",
        resolution: "解像度",
        ratio: "比例",
        background: "背景",
        backgroundAuto: "自動",
        backgroundOpaque: "保留背景",
        backgroundTransparent: "透明背景",
        quality: "解像度",
        duration: "影片時長",
        quantityValue: "{count}張",
        quantityValueVideo: "{count}個",
        points: "積分",
        selectModel: "選擇模型",
        selectStyle: "選擇風格",
        allStyles: "全部風格",
        parameters: "參數",
      },
      audioPreview: "音訊預覽",
      mention: {
        search: "輸入關鍵字搜尋",
        empty: "暫時未有資料",
        tabs: { reference: "參考", asset: "素材", material: "素材庫" },
        assetFilters: { role: "人物", scene: "場景", prop: "道具" },
        assetSource: { script: "片段", project: "項目" },
        materialFilters: {
          all: "全部",
          other: "其他",
          character: "人物",
          scene: "場景",
          item: "物品",
          style: "風格",
          sound: "音訊",
          project: "項目空間",
        },
        // 同一提示词里素材与其他 @ 重名时的自动改名
        sameNameAlias: {
          image: "{name}（圖片）",
          video: "{name}（影片）",
          audio: "{name}（音訊）",
        },
        sameNameAliasIndexed: {
          image: "{name}（圖片{index}）",
          video: "{name}（影片{index}）",
          audio: "{name}（音訊{index}）",
        },
      },
      videoModelLimits: {
        maxImages: "當前模型引用圖片不能超過{count}張",
        maxVideos: "當前模型引用影片不能超過{count}個",
        maxAudios: "當前模型引用音訊不能超過{count}個",
        maxTotal: "當前模型引用圖片／影片／音訊總數不能超過{count}個",
        maxVideoDuration: "當前模型引用影片總時長不能超過{seconds}s",
        maxAudioDuration: "當前模型引用音訊總時長不能超過{seconds}s",
        audioNotSupported: "當前模型唔支援音訊引用",
        maxImageAndVideo: "當前模型圖片同影片引用總數不能超過{count}個",
        audioVideoNotSupportedAsReference: "當前模型唔支援音訊影片作為參考",
        referenceNotSupported: "當前模型唔支援引用參考素材",
        maxVideoWithOutputDuration: "當前模型引用影片總時長加生成時長不能超過{seconds}s",
        promptRequired: "當前模型文生影片需要填寫提示詞",
        untitledFile: "未命名檔案",
        fileFailedDetail: "當前模型「{fileName}」{message}",
        animatedNotSupported: "當前模型唔支援動圖作為參考",
        audioOnlyNotSupported: "當前模型引用參考不能只有音訊",
        klingPromptTooLong: "當前模型提示詞不能超過{max}個字元",
      },
      imageModelLimits: {
        maxImages: "當前模型引用圖片不能超過{count}張",
        animatedNotSupported: "當前模型唔支援動圖作為參考",
      },
    },
    compose: {
      generating: "影片生成中",
      videoUnsupported: "你嘅瀏覽器唔支援 HTML5 video 標籤。",
    },
    assets: {
      selectAssignData: "請選擇要分配嘅資料",
      batchStarted: "批量生成已開始",
      batchFailed: "批量生成失敗",
      generatingCannotDelete: "資產生成中，請等生成完成後再刪除",
      noModels: "暫時未有可用模型",
      roles: {
        list: "角色列表",
        more: "更多角色",
        batchTitle: "批量生成角色",
        searchPlaceholder: "搜尋角色名",
        empty: "暫時未有角色",
        emptyTip: "撳下面個按鈕建立你第一個角色",
        emptySearch: "搵唔到符合嘅角色",
        emptySearchTip: "試下用其他關鍵字搜尋",
        create: "建立角色",
        deleteConfirm: "確定刪除呢個角色？",
        selectBatchWarning: "請先揀選要批量生成嘅角色",
        gender: { unlimited: "不限", male: "男", female: "女" },
        age: {
          unknown: "不詳",
          childhood: "幼兒",
          child: "兒童",
          teen: "少年",
          young: "青年",
          middle: "中年",
          senior: "長者",
        },
        dialog: {
          createTitle: "建立角色形象",
          editTitle: "編輯角色形象",
          closeTip: "關閉視窗唔會中斷進行緊嘅任務",
          close: "關閉",
          name: "角色名",
          gender: "性別",
          age: "年齡組",
          enter: "請輸入",
          select: "請選擇",
          generationMode: "生成方式",
          generateByModel: "透過模型生成圖片",
          uploadImage: "自己上載圖片",
          addImage: "新增圖片",
          formatHint: "支援 PNG、JPG、JPEG、BMP，最大 10MB",
          model: "選擇模型",
          ratio: "比例",
          resolution: "解像度",
          style: "風格",
          prompt: "提示詞",
          promptPlaceholder:
            "請描述角色嘅外觀，包括但不限於性別、年齡、服裝、氣質等。",
          uploadReference: "上載參考",
          generateImage: "生成圖片",
          generatingWarning: "生成圖片期間請勿關閉視窗，關閉會令圖片生成異常。",
          saveChanges: "儲存變更",
          voice: "音色",
          preview: "試聽",
          pausePreview: "暫停",
          imageCount: "圖片數量",
          imageCountValue: "{count}張",
          startGenerate: "撳呢度開始生成",
          calculating: "計算緊",
          records: "生成記錄",
          recordsHint: "選擇記錄內的圖片之後，按儲存套用這張圖片。",
          generationFailed: "圖片生成失敗",
          failed: "生成失敗",
          noRecords: "暫時未有記錄",
          saveSettings: "儲存設定",
          validation: {
            name: "請輸入角色名",
            gender: "請選擇性別",
            age: "請選擇年齡組",
            prompt: "請輸入提示詞",
            model: "請選擇模型",
            ratio: "請選擇比例",
            resolution: "請選擇解像度",
            style: "請選擇風格",
          },
          messages: {
            singleFileOnly:
              "只可以上載一個檔案，如有需要請先刪除上一個檔案再上載",
            loginExpired: "登入狀態已失效，請重新登入",
            uploadFailed: "上載失敗",
            imageUploadFailed: "圖片上載失敗",
            invalidFormat: "上載嘅檔案格式唔正確",
            fileTooLarge: "上載圖片大小唔可以超過 10MB",
            missingImageId: "缺少圖片記錄 ID",
            deleteConfirm: "確定刪除呢張圖片？",
            deleteSuccess: "刪除成功",
            pointsFailed: "取得消耗積分失敗",
            operationFailed: "操作失敗",
            saveFailed: "儲存失敗",
            selectCompletedBeforeSave: "請先揀已生成完成嘅圖片再儲存",
            previewUnavailable: "呢個音色暫時未有試聽音訊",
            previewFailed: "音色試聽失敗",
          },
        },
      },
      scenes: {
        list: "場景列表",
        more: "更多場景",
        batchTitle: "批量生成場景",
        searchPlaceholder: "搜尋場景名",
        empty: "暫時未有場景",
        emptyTip: "撳下面個按鈕建立你第一個場景",
        emptySearch: "搵唔到符合嘅場景",
        emptySearchTip: "試下用其他關鍵字搜尋",
        create: "建立場景",
        deleteConfirm: "確定刪除呢個場景？",
        selectBatchWarning: "請先揀選要批量生成嘅場景",
        dialog: {
          createTitle: "建立場景",
          editTitle: "編輯場景",
          closeTip: "關閉視窗唔會中斷進行緊嘅任務",
          close: "關閉",
          name: "場景名稱",
          namePlaceholder: "請輸入場景名稱",
          select: "請選擇",
          generationMode: "生成方式",
          generateByModel: "透過模型生成圖片",
          uploadImage: "自己上載圖片",
          addImage: "新增圖片",
          formatHint: "支援 PNG、JPG、JPEG、BMP，最大 10MB",
          model: "選擇模型",
          ratio: "比例",
          resolution: "解像度",
          style: "風格",
          prompt: "提示詞",
          promptPlaceholder:
            "詳細描述場景，例如空間、時間、天氣、光線、標誌性物件、背景元素、整體環境、年代、題材、美術風格同圖片視角等。",
          uploadReference: "上載參考",
          generateImage: "生成圖片",
          generatingWarning: "生成圖片期間請勿關閉視窗，關閉會令圖片生成異常。",
          saveChanges: "儲存變更",
          time: "時間",
          timePlaceholder: "例如：清晨、正午、黃昏、夜晚……",
          weather: "天氣",
          weatherPlaceholder: "例如：天晴、陰天、微雨、大雨、薄霧……",
          light: "光線",
          lightPlaceholder: "例如：日光、暖光、月光、燭光、逆光……",
          imageCount: "圖片數量",
          imageCountValue: "{count}張",
          startGenerate: "撳呢度開始生成",
          calculating: "計算緊",
          records: "生成記錄",
          recordsHint: "揀選記錄入面嘅圖片之後，撳儲存套用呢張圖片。",
          generationFailed: "圖片生成失敗",
          failed: "生成失敗",
          noRecords: "暫時未有記錄",
          saveSettings: "儲存設定",
          validation: {
            name: "請輸入場景名稱",
            prompt: "請輸入提示詞",
            model: "請選擇模型",
            ratio: "請選擇比例",
            resolution: "請選擇解像度",
            style: "請選擇風格",
          },
          messages: {
            singleFileOnly:
              "只可以上載一個檔案，如有需要請先刪除上一個檔案再上載",
            loginExpired: "登入狀態已失效，請重新登入",
            uploadFailed: "上載失敗",
            invalidFormat: "上載嘅檔案格式唔正確",
            fileTooLarge: "上載圖片大小唔可以超過 10MB",
            missingImageId: "缺少圖片記錄 ID",
            deleteConfirm: "確定刪除呢張圖片？",
            deleteSuccess: "刪除成功",
            pointsFailed: "取得消耗積分失敗",
            operationFailed: "操作失敗",
            saveFailed: "儲存失敗",
            selectCompletedBeforeSave: "請先揀已生成完成嘅圖片再儲存",
            uploadReference: "請上載參考圖",
          },
        },
      },
      props: {
        list: "道具列表",
        more: "更多道具",
        batchTitle: "批量生成道具",
        searchPlaceholder: "搜尋道具名",
        empty: "暫時未有道具",
        emptyTip: "撳下面個按鈕建立你第一個道具",
        emptySearch: "搵唔到符合嘅道具",
        emptySearchTip: "試下用其他關鍵字搜尋",
        create: "建立道具",
        deleteConfirm: "確定刪除呢個道具？",
        selectBatchWarning: "請先揀選要批量生成嘅道具",
        dialog: {
          createTitle: "建立道具",
          editTitle: "編輯道具",
          closeTip: "關閉視窗唔會中斷進行緊嘅任務",
          close: "關閉",
          name: "道具名",
          namePlaceholder: "請輸入",
          select: "請選擇",
          generationMode: "生成方式",
          generateByModel: "透過模型生成圖片",
          uploadImage: "自己上載圖片",
          addImage: "新增圖片",
          formatHint: "支援 PNG、JPG、JPEG、BMP，最大 10MB",
          model: "選擇模型",
          ratio: "比例",
          resolution: "解像度",
          style: "風格",
          prompt: "提示詞",
          promptPlaceholder: "請描述你想生成嘅道具",
          uploadReference: "上載參考",
          generateImage: "生成圖片",
          generatingWarning: "生成圖片期間請勿關閉視窗，關閉會令圖片生成異常。",
          saveChanges: "儲存變更",
          imageCount: "圖片數量",
          imageCountValue: "{count}張",
          startGenerate: "撳呢度開始生成",
          calculating: "計算緊",
          records: "生成記錄",
          recordsHint: "揀選記錄入面嘅圖片之後，撳儲存套用呢張圖片。",
          generationFailed: "圖片生成失敗",
          failed: "生成失敗",
          noRecords: "暫時未有記錄",
          saveSettings: "儲存設定",
          validation: {
            name: "請輸入道具名",
            prompt: "請輸入提示詞",
            model: "請選擇模型",
            ratio: "請選擇比例",
            resolution: "請選擇解像度",
            style: "請選擇風格",
          },
          messages: {
            singleFileOnly:
              "只可以上載一個檔案，如有需要請先刪除上一個檔案再上載",
            loginExpired: "登入狀態已失效，請重新登入",
            uploadFailed: "上載失敗",
            invalidFormat: "上載嘅檔案格式唔正確",
            fileTooLarge: "上載圖片大小唔可以超過 10MB",
            missingImageId: "缺少圖片記錄 ID",
            deleteConfirm: "確定刪除呢張圖片？",
            deleteSuccess: "刪除成功",
            pointsFailed: "取得消耗積分失敗",
            operationFailed: "操作失敗",
            saveFailed: "儲存失敗",
            selectCompletedBeforeSave: "請先揀已生成完成嘅圖片再儲存",
            uploadReference: "請上載參考圖",
          },
        },
      },
      review: {
        title: "真人審核",
        notSubmitted: "未提交真人審核",
        reviewing: "平台真人審核緊",
        rejected: "平台真人審核未通過",
        approved: "平台真人審核通過",
        notReviewed: "未審核",
        reviewingShort: "審核緊",
        failed: "審核失敗",
        approvedShort: "審核通過",
        noError: "暫時冇錯誤資料",
        confirmTitle: "確認提交審核？",
        confirmMessage:
          "提交之後，目前資料會進入待審核狀態，管理員通過或打回之前都唔可以再編輯。",
        approveTitle: "確定通過",
        approveMessage: "係咪通過目前資料？",
      },
      materials: {
        list: "素材列表",
        upload: "上載素材",
        categoriesLabel: "素材分類",
        preview: "預覽素材 {name}",
        categories: {
          all: "全部",
          character: "人物",
          scene: "場景",
          object: "道具",
          audio: "音訊",
          other: "其他",
        },
        dialog: {
          name: "素材名稱",
          namePlaceholder: "請輸入素材名稱",
          category: "素材分類",
          categoryPlaceholder: "請選擇素材分類",
          file: "上載檔案",
          fileRequired: "請選擇要上載嘅檔案",
          dragHere: "將檔案拖到呢度，或者",
          clickSelect: "撳呢度選擇",
          editTitle: "編輯素材",
          add: "新增素材",
        },
        validation: {
          fileInvalid: "檔案唔符合上載要求",
          uploadFailedReselect: "檔案上載失敗，請重新選擇檔案",
          waitForUpload: "檔案上載完成之後先可以新增素材",
          unsupportedType: "只支援上載圖片、影片或者音頻素材",
          imageFormat:
            "圖片格式只支援 jpeg、png、webp、bmp、tiff、gif、heic/heif",
          videoFormat: "影片格式只支援 mp4、mov",
          audioFormat: "音頻格式只支援 wav、mp3",
          formatUnsupported: "唔支援呢種檔案格式",
          imageSize: "圖片大小要細過 30 MB",
          videoSize: "影片大小唔可以超過 50 MB",
          audioSize: "音頻大小唔可以超過 15 MB",
          sizeExceeded: "檔案大小超出限制",
          videoDurationUnreadable: "無法讀取影片時長",
          audioDurationUnreadable: "無法讀取音頻時長",
          videoDurationRange: "影片時長要喺 {min} 至 {max} 秒之間",
          audioDurationRange: "音頻時長要喺 {min} 至 {max} 秒之間",
          videoSizeUnreadable: "無法讀取影片尺寸",
          imageSizeUnreadable: "無法讀取圖片尺寸",
          videoSideRange: "影片寬高要喺 {min} 至 {max} px 之間",
          imageSideRange: "圖片寬高要大過 {min} px 而且細過 {max} px",
          videoRatioRange: "影片寬高比要喺 {min} 至 {max} 之間",
          imageRatioRange: "圖片寬高比要大過 {min} 而且細過 {max}",
          videoResolution: "影片解像度只支援 480p、720p、1080p",
          videoPixels: "影片總像素數要喺 {min} 至 {max} 之間",
          videoFpsUnreadable: "無法讀取影片幀率",
          videoFpsRange: "影片幀率要喺 {min} 至 {max} FPS 之間",
          videoInfoUnreadable: "無法讀取影片資料",
          audioInfoUnreadable: "無法讀取音頻資料",
          credentialFailed: "取得上載憑證失敗",
          saveUploadInfoFailed: "儲存上載檔案資料失敗",
          credentialIncomplete: "上載憑證缺少必要欄位",
          uploadFailed: "上載失敗",
        },
        deleteConfirm: "確定刪除呢個素材？",
        messages: {
          listFailed: "取得素材列表失敗",
          scopeMissing: "缺少素材歸屬資料",
          urlMissing: "缺少素材檔案地址",
          idMissing: "缺少素材 ID",
          saveFailed: "儲存素材失敗",
          added: "新增成功",
          deleteFailed: "刪除失敗",
        },
      },
    },
    units: {
      currency: "港元",
      episode: "集",
      second: "秒",
    },
    projects: {
      title: "我的項目",
      searchPlaceholder: "搜尋項目名稱",
      empty: "暫時沒有項目",
      emptyTip: "按以下按鍵建立你第一個AI漫畫項目",
      noMatch: "搵唔到符合嘅項目",
      tryAnotherKeyword: "試吓用其他關鍵字搜尋",
      create: "建立項目",
      add: "新增項目",
      actions: {
        statistics: "素材統計",
        details: "項目詳情",
        edit: "編輯項目",
        delete: "刪除項目",
        addMember: "新增成員",
      },
      statistics: {
        title: "素材統計",
        roles: "角色圖片數量",
        scenes: "場景圖片數量",
        props: "道具圖片數量",
      },
      details: {
        title: "項目詳情",
        creator: "建立者帳戶",
      },
      form: {
        name: "項目名稱",
        namePlaceholder: "請輸入項目名稱",
        budget: "項目預算",
        budgetPlaceholder: "請輸入項目預算",
        episodes: "集數",
        episodesPlaceholder: "請輸入集數",
        episodeDuration: "每集時長",
        durationPlaceholder: "請輸入每集時長",
        description: "項目說明",
        descriptionPlaceholder: "請填寫項目說明",
      },
      deleteConfirm: {
        message: "確定刪除呢個項目？刪除之後無法還原。",
        confirm: "確定刪除",
      },
    },
    management: {
      nav: {
        clips: "片段管理",
        roles: "角色管理",
        scenes: "場景管理",
        props: "道具管理",
        materials: "素材管理",
      },
      clips: {
        searchPlaceholder: "搜尋片段名稱",
        empty: "暫時未有片段",
        emptyTip: "撳下面按鈕建立你第一個片段",
        noMatch: "搵唔到符合嘅片段",
        create: "新增片段",
        createDialog: "建立片段",
        edit: "編輯片段",
        delete: "刪除片段",
        videoStatistics: "影片統計",
        storyboardVideos: "分鏡生成影片",
        episodeTitle: "集數 Ep{name}",
        name: "片段名稱",
        namePlaceholder: "請輸入片段名稱",
        description: "片段說明",
        descriptionPlaceholder: "請填寫片段說明",
        deleteConfirm: {
          message: "確定刪除呢個片段？刪除之後無法還原。",
          confirm: "確定刪除",
        },
      },
    },
    members: {
      settings: "成員設定",
      usernamePlaceholder: "請輸入用戶名",
      count: "項目成員：{count}人",
      user: "用戶",
      username: "用戶名",
      role: "角色",
      selectMember: "請選擇要分配嘅成員",
    },
    returnData: {
      title: "退回資料",
      reason: "退回原因",
      placeholder: "請輸入退回原因，Ctrl + V 貼上圖片",
      imageTooLarge: "圖片唔可以超過 5MB",
    },
    review: {
      submit: "提交真人審核",
      refresh: "重新整理審核狀態",
      hide: "隱藏審核狀態",
      show: "顯示審核狀態",
      submitSuccess: "已成功提交真人審核",
    },
    validation: {
      projectStatus: "請選擇項目狀態",
      number: "請輸入數字",
      maxDigits: "最多輸入 10 位數字",
      positiveInteger: "請輸入大過 0 嘅正整數",
      projectNameRequired: "項目名稱唔可以留空",
      length2To20: "長度要係 2-20 個字元",
    },
    permissions: {
      noCreate: "你冇新增權限",
      notOwner: "你唔係呢份資料嘅負責人",
      noOperation: "你冇操作權限",
    },
    messages: {
      created: "建立成功",
      updated: "修改成功",
      deleted: "刪除成功",
      assigned: "分配成功",
      operationSuccess: "操作成功",
      operationFailed: "操作失敗",
      uploadFailed: "上載失敗",
    },
  },
  scriptCreation: {
    insufficientPoints: {
      coin: "幣",
      title: "積分不足",
      description: "生成劇本需要消耗積分，您目前嘅積分餘額不足。",
      required: "/ 需要 {value}",
      deficit: "仲差 {value} 積分",
      recharge: "去增值",
      refreshTip: "增值完成後請重新整理頁面",
    },
    common: {
      back: "返回",
      cancel: "取消",
      loading: "載入中",
      loadingDots: "載入中...",
      script: "劇本",
      outline: "大綱",
      scriptOutline: "劇本大綱",
      notSelected: "未選擇",
      notFilled: "未填寫",
      custom: "自訂",
      unknown: "未知",
      listSeparator: "、",
      episodeUnit: "集",
      minuteUnit: "分鐘",
      episodeCount: "{count}集",
      durationMinutes: "{count}分鐘",
    },
    workbench: {
      title: "工作台",
      subtitle: "歡迎返嚟，開始你嘅創作之旅",
      startTitle: "開始創作",
      startDesc: "建立新劇本項目",
      scriptsTitle: "我嘅劇本",
      projectCount: "{count}個項目",
    },
    list: {
      title: "我的劇本",
      searchPlaceholder: "搜尋劇本名稱...",
      newScript: "新建劇本",
      loading: "劇本列表載入中...",
      empty: "暫無劇本，撳右上角「新建劇本」開始創作",
      view: "查看",
      download: "下載",
      delete: "刪除",
      deleting: "刪除中",
    },
    saveSuccess: {
      saved: "儲存成功",
      title: "儲存成功！",
      desc: "你嘅劇本已成功儲存到劇本庫",
      backWorkbench: "返回工作台",
      createComic: "一鍵創作漫劇",
      viewScripts: "查看我嘅劇本",
    },
    steps: {
      story: { name: "一句話故事", desc: "故事起點" },
      genre: { name: "題材配置", desc: "故事方向" },
      params: { name: "參數配置", desc: "畫面參數設定" },
      outline: { name: "劇本大綱", desc: "預覽同確認" },
    },
    summary: {
      title: "創作設定",
      note: "AI 會根據呢啲配置調整劇本節奏、人物關係同畫面描述。",
      story: "一句話故事",
      genre: "題材",
      subGenre: "子題材",
      creationStyle: "創作風格",
      keywords: "關鍵詞",
      episodeCount: "集數",
      duration: "單集時長",
      ratio: "畫面比例",
      resolution: "解像度",
      videoStyle: "影片風格",
    },
    story: {
      label: "一句話故事（AI會分析你的故事推薦題材風格, 沒有填寫都可以繼續）",
      placeholder:
        "描述故事核心設定、衝突同亮點。例如：現代職場女性意外穿越到古代，與冷面王爺相識相愛的故事。",
    },
    genre: {
      selectGenre: "選擇題材",
      customGenreLabel: "自訂題材（唔超過20字）",
      customGenrePlaceholder: "輸入題材名稱...",
      selectSubGenre: "選擇子題材",
      multiSelectHint: "可多選，用逗號分隔多個標籤",
      loadingSubGenres: "正在載入子題材...",
      customSubGenrePlaceholder: "+ 自訂子題材",
      keywordTags: "關鍵詞標籤",
      loadingKeywords: "正在載入關鍵詞...",
      customKeywordPlaceholder: "+ 加自訂關鍵詞",
      creationStyle: "創作風格",
    },
    params: {
      episodeTitle: "集數設定",
      episodeDesc: "設定劇本總集數（單次最多 {count} 集）",
      durationTitle: "單集時長",
      durationDesc: "每集影片時長",
      ratioTitle: "畫面比例",
      resolutionTitle: "解像度",
      videoStyleTitle: "影片風格",
      videoStyleHint: "滑鼠懸停查看預覽",
      modelTitle: "選擇大模型",
    },
    outline: {
      summary: "劇本概括",
      worldview: "世界觀設定",
      theme: "核心主題",
      summaryNote: "AI 根據你嘅一句話故事生成咗大綱，你可以直接編輯修改。",
      editNameAria: "編輯劇本名字",
    },
    detail: {
      backAria: "返回",
      model: "模型",
      parameters: "參數",
      messages: {
        noOutlineContent: "暫無大綱內容",
        episodeSaveFailed: "分集儲存失敗",
        episodeDetailSaveFailed: "分集詳細內容儲存失敗",
        characterSaveFailed: "角色儲存失敗",
        characterReferencedCannotEdit: "呢個人物已被分集概括引用，唔可以修改",
        characterReferencedCannotDelete: "呢個人物已被分集概括引用，唔可以刪除",
        characterCannotDelete: "呢個人物唔可以刪除",
        characterReferencedCannotRename:
          "呢個人物已被分集概括引用，唔可以修改名字",
        characterNameExists: "人物名稱已存在",
        characterDeleteFailed: "角色刪除失敗",
        newCharacterName: "新人物{n}",
        rolePending: "待補充",
        characterDescPlaceholderDefault: "請補充人物設定。",
        newAvatar: "新",
        personFallback: "人",
        goalLabel: "目標：",
        storyFunctionLabel: "劇情作用：",
        roleTypePerson: "人物",
        protagonistTeam: "主角團隊",
        mainCharacter: "主角",
        partner: "拍檔",
        indoor: "室內",
        infoHotspot: "資訊爆點",
        expectationHook: "期待式鈎子",
        episodeListFailed: "取得分集列表失敗",
        episodeDetailFailed: "取得分集詳情失敗",
        episodeDetailTimeout: "分集詳細內容生成逾時，請稍後重新整理頁面查看",
        episodeIdMissing: "分集ID不存在，無法生成詳細內容",
        selectTextModel: "請先選擇文字模型",
        mockEpisodePlot:
          "{description} 本集圍繞{people}展開，透過衝突推進人物關係，並喺結尾設置新懸念。",
        mockExplorerCommandBridge: "探索者號指揮艙",
        mockMainConsoleArea: "主控台前",
        mockEpisodeScript:
          "第1場 · 室內 · 探索者號指揮艙\n時間：深夜\n\n▽警報燈喺艙壁上緩慢閃爍，藍色光芒喺角色臉上流動。\n\n◆{protagonist}\n> 【冷】「全員注意，進入未知區域。各部門報告狀況。」\n\n▽數據流好似瀑布噉由屏幕墜落，新嘅信號座標被鎖定。\n\n◆{partner}\n> 【緊】「相似度達到98.7%，建議立即派遣調查隊。」\n\n▽主角沉默片刻，目光落喺不斷跳動嘅座標上。\n\n◆{protagonist}\n> 【忍】「準備登陸程序。十分鐘後喺發射艙集合。」\n\n▽鏡頭掠過舷窗，未知星體嘅輪廓喺黑暗中逐漸清晰。\n\n本集結束。",
        mockHotspotDescription:
          "喺普通調查中突然發現高相似度信號，突出未知嘅奇異感同看點。",
        mockHookDescription:
          "類地行星上究竟存在啲咩？調查隊登陸後會面對點樣嘅未知？",
        mockEpisodeSummary:
          "本集以任務開啟同異常信號為核心，快速建立懸念，並為後續調查隊登陸行動鋪墊。",
      },
      nav: {
        all: "全部",
        outline: "大綱",
        characters: "人物設定",
        episodes: "分集概括",
        episodeDetails: "分集詳情",
      },
      noEpisodeDetails: "暫無詳細內容",
      episode: "第{n}集",
      storyOutline: "故事大綱",
      characters: "人物設定",
      addCharacter: "新增人物",
      characterNamePlaceholder: "請輸入人物名",
      characterRolePlaceholder: "請輸入人物身份",
      characterDescPlaceholder: "請輸入人物設定",
      episodeSummary: "分集概括",
      includedCharacters: "包含人物：",
      addEpisodeCharacter: "添加人物",
      generationFailed: "生成失敗",
      detailGenerated: "已生成本集詳細內容",
      generating: "生成中...",
      regenerate: "重新生成",
      generateEpisode: "生成本集劇本",
      episodeDetail: {
        plot: "本集詳細劇情",
        plotHint: "300-500字，詳細描述本集發生嘅故事",
        cast: "出場人物",
        scenes: "場景列表",
        script: "詳細劇本",
        scriptHint:
          "包含場景劃分、畫面／鏡頭描述、人物動作、角色對白（附情緒標籤）",
        scriptPlaceholder: "請輸入詳細劇本",
        copy: "複製",
        copySuccess: "劇本文字已複製",
        copyFailed: "複製失敗",
        highlights: "爆點強化建議",
        hotspot: "爆點",
        hook: "追更鈎子設計",
        summary: "創作總結",
        generationStarted: "已開始生成分集詳細內容",
        regenerationStarted: "已開始重新生成分集詳細內容",
        generateFailed: "分集詳細內容生成失敗",
      },
      scriptTitleFallback: "劇本詳情",
      scriptGenre: "劇本題材",
      customValue: "自訂",
      defaultValue: "預設",
      episodeCountValue: "{n}集",
      durationValue: "{n}分鐘",
      generatedHint: "劇本內容已生成，你可以查看或者編輯劇本內容。",
      saveScript: "儲存劇本",
      exporting: "匯出中...",
      exportTxt: "匯出 TXT",
    },
    generating: {
      scriptTitle: "AI 正在生成劇本...",
      waitTip: "預計需要 3-5 分鐘，請稍候",
    },
    wizard: {
      next: "下一步",
      generateOutline: "開始生成大綱 {count}",
      regenerate: "重新生成",
      generateScript: "確認並生成劇本 {count}集",
    },
    headers: {
      story: "故事起點",
      genre: "題材配置",
      params: "參數配置",
    },
    footerHints: {
      story: "你的一句話故事，會是 AI 創作嘅核心靈感。",
      genre: "AI 會基於你的題材選擇輔助創作，你亦可以隨時自訂調整。",
      params:
        "AI 會根據畫面比例、風格等參數，調整劇本場景描述同節奏，以配合影片製作需要",
      outline: "AI 根據你嘅一句故事生成咗大綱，你可以直接編輯修改。",
    },
    validation: {
      maxChars: "輸入內容唔可以超過{count}個字",
    },
    status: {
      initializingEngine: "正在初始化創作引擎...",
      parsingGenre: "正在解析題材：{genre}...",
      buildingStory: "正在構建故事框架...",
      generatingWorldview: "正在生成世界觀設定...",
      writingSummary: "正在撰寫劇本概括...",
      almostDone: "即將完成...",
      organizingOutline: "正在整理大綱內容...",
      outlineDone: "大綱生成完成",
      generatingOutline: "AI 正在生成大綱...",
      generatingCharacters: "正在生成角色設定...",
      writingEpisodes: "正在撰寫分集大綱...",
      enrichingDetails: "正在豐富劇情細節...",
      scriptDone: "劇本生成完成",
      organizingScript: "正在整理劇本分集內容...",
      viewingOutline: "正在查看劇本大綱...",
    },
    messages: {
      outlineSaveFailed: "大綱儲存失敗",
      genreListFailed: "取得題材列表失敗",
      subGenreListFailed: "取得子題材列表失敗",
      keywordListFailed: "取得關鍵詞列表失敗",
      pointsNotEnough: "積分不足",
      pointsCheckFailed: "積分校驗失敗",
      outlineTaskCreateFailed: "大綱生成任務建立失敗",
      outlineGenerateFailed: "大綱生成失敗",
      projectMissingRegenerate: "劇本項目ID不存在，無法重新生成",
      outlineStatusFailed: "大綱生成狀態查詢失敗",
      outlineResultEmpty: "大綱生成結果為空",
      outlineDetailFailed: "取得大綱詳情失敗",
      cancelOutlineFailed: "取消生成大綱失敗",
      projectMissingScript: "劇本項目ID不存在，無法生成劇本",
      scriptTaskCreateFailed: "劇本分集生成任務建立失敗",
      scriptGenerateFailed: "劇本分集生成失敗",
      scriptStatusFailed: "劇本分集生成狀態查詢失敗",
      aiUnavailable: "AI 服務暫時不可用，請稍後再試。",
      cancelScriptFailed: "取消生成劇本分集失敗",
      scriptDetailFailed: "取得劇本詳情失敗",
      scriptResultEmpty: "劇本分集生成結果為空",
      outlineConfirmed: "劇本大綱已確認",
      featureComingSoon: "功能開發中，敬請期待！",
      scriptListFailed: "取得劇本列表失敗",
      scriptIdMissingView: "劇本ID不存在，無法查看詳情",
      noDownloadableScript: "呢條記錄暫無可下載劇本",
      deleteConfirm: "確定刪除呢個劇本嗎？刪除後不可恢復。",
      deleteTitle: "提示",
      confirmDelete: "確定刪除",
      scriptIdMissingDelete: "劇本ID不存在，無法刪除",
      deleteSuccess: "刪除成功",
      deleteFailed: "刪除失敗",
      downloadFailed: "劇本下載失敗",
      scriptIdMissingExport: "劇本 ID 不存在，無法匯出",
    },
    presets: {
      genres: {
        romance: { name: "愛情" },
        suspense: { name: "懸疑" },
        fantasy: { name: "奇幻" },
        scifi: { name: "科幻" },
        historical: { name: "古裝" },
        comedy: { name: "喜劇" },
        action: { name: "動作" },
        horror: { name: "恐怖" },
        school: { name: "校園" },
        career: { name: "職場" },
        custom: { name: "自訂" },
      },
      tags: {
        timeTravel: "穿越",
        urban: "都市",
        childhoodSweethearts: "青梅竹馬",
        marriageFirst: "先婚後愛",
        misunderstanding: "誤會",
        reunion: "重逢",
        growth: "成長",
        mutualCommitment: "雙向奔赴",
        criminalInvestigation: "刑偵",
        lockedRoom: "密室",
        psychological: "心理",
        urbanLegend: "都市怪談",
        truth: "真相",
        twist: "反轉",
        evidence: "證據",
        tracking: "追蹤",
        isekai: "異世界",
        magic: "魔法",
        cultivation: "修仙",
        superpower: "超能力",
        adventure: "冒險",
        awakening: "覺醒",
        destiny: "宿命",
        secretRealm: "秘境",
        interstellar: "星際",
        ai: "AI",
        timeLoop: "時間循環",
        apocalypse: "末日",
        civilization: "文明",
        exploration: "探索",
        crisis: "危機",
        restart: "重啟",
        palace: "宮廷",
        martialWorld: "江湖",
        powerStruggle: "權謀",
        court: "朝堂",
        identity: "身世",
        revenge: "復仇",
        alliance: "盟約",
        workplace: "職場",
        family: "家庭",
        antiTrope: "反套路",
        accidentalChaos: "誤打誤撞",
        hilarious: "爆笑",
        contrast: "反差",
        comeback: "逆襲",
        agent: "特工",
        hotBlooded: "熱血",
        racing: "競速",
        combat: "格鬥",
        chase: "追逐",
        confrontation: "對抗",
        rescue: "救援",
        team: "團隊",
        supernatural: "靈異",
        folklore: "民俗",
        thriller: "驚悚",
        denseForest: "密林",
        curse: "詛咒",
        taboo: "禁忌",
        escape: "逃生",
        unknown: "未知",
        youth: "青春",
        club: "社團",
        graduation: "畢業",
        friendship: "友情",
        dream: "夢想",
        crush: "心動",
        regret: "遺憾",
        startup: "創業",
        businessWar: "商戰",
        legal: "律政",
        medical: "醫療",
        competition: "競爭",
        choice: "抉擇",
        breakthrough: "突破",
        partner: "伙伴",
        originalGenre: "原創題材",
        hybridGenre: "混合類型",
        freeCreation: "自由創作",
        differentiation: "差異化",
      },
      styles: {
        seriousRealistic: "嚴肅寫實",
        lightComedy: "輕鬆搞笑",
        mysteryHumor: "懸疑幽默",
        hotBlooded: "熱血燃向",
        healingWarm: "治癒溫暖",
        darkOppressive: "暗黑壓抑",
        literaryFresh: "文藝清新",
        epicDrama: "劇情宏大",
        powerFantasy: "無腦爽文",
      },
      videoStyles: {
        chinese3d: "3D國漫",
        japaneseAnime: "日系動漫",
        realistic: "寫實風",
        inkWash: "水墨風",
        pixel: "像素風",
        cyberpunk: "賽博朋克",
        minimalLine: "極簡線條",
      },
    },
  },
  projectLibrary: {
    personal: "個人項目",
    groups: "項目組",
    groupsWithCount: "項目組 ({count})",
    createGroup: "新建項目組",
    createGroupNoPermission: "只有超級管理員、管理員同子管理員可以建立項目組",
    emptyNoGroups: "暫無項目組",
    emptyNoGroupsHint: "請聯絡管理員建立或邀請你加入",
    members: "{count} 名成員",
    inviteOpen: "邀請連結開",
    inviteClosed: "未開啟邀請",
    inviteDisconnected: "邀請連結已斷開",
    available: "項目可用 {used} / {total}",
    quotaFixed: "固定額度 · {n}/人",
    quotaGift: "贈送額度 · {n}/人",
    quotaExclusive: "獨享額度 · {n}/人",
    quotaUnlimited: "不限額",
    statusRunning: "進行中",
    statusPaused: "暫停",
    statusFilterPaused: "已暫停",
    statusFinished: "已完畢",
    statusClosed: "已關閉",
    fetchListFailed: "取得項目組列表失敗",
    noMatch: "搵唔到符合嘅項目組",
    tryAnotherKeyword: "試吓用其他關鍵字搜尋",
    create: {
      titleCanvas: "新建泫宗畫布項目組",
      subtitle: "一次完成項目設定、成員選擇同邀請配置",
      close: "關閉建立項目組",
      stepLabel: "步驟 {current}/3 · {name}",
      step1: "基本資訊同額度",
      step1Desc: "設定項目名稱、積分同成員通用額度",
      step2: "新增學校學生",
      step3: "邀請設定",
      name: "項目組名稱",
      namePlaceholder: "請輸入項目組名稱",
      allocate: "劃入項目積分",
      allocatePlaceholder: "請輸入劃入積分",
      allocateHint: "優先用訂閱積分",
      creatorAvailable: "建立者可用積分",
      quotaMode: "成員額度模式",
      quotaPerMember: "每人項目總額度",
      quotaPerMemberPlaceholder: "請輸入每人額度",
      modeFixed: "固定額度 · 全員一致",
      modeGift: "贈送額度 · 全員一致",
      modeExclusive: "獨享額度 · 全員一致",
      modeUnlimited: "不限額 · 共用項目餘額",
      step1Tip:
        "項目積分會從你嘅可用積分扣除，只限而家呢個{scene}項目組用，唔夠都唔會自動用成員個人積分。",
      sceneCanvas: "泫宗畫布",
      addMembers: "新增成員",
      addMembersTip: "可以按組織批量勾選，建立之後統一套用額度",
      searchStudent: "搜尋學校學生",
      searchStudentPlaceholder: "暱稱或手機號",
      searchMemberPlaceholder: "搜尋姓名、手機號、角色或帳號層級",
      colName: "姓名",
      colLevel: "帳號層級",
      colPhone: "手機號",
      colRole: "角色",
      allMembers: "全部成員 ({count}人)",
      allMembersLabel: "全部成員",
      allMembersCount: "{count}人",
      selectSubtree: "全部選擇",
      deselectSubtree: "取消全選",
      selfLockedTip: "建立者預設加入，唔可以取消勾選",
      step2Tip:
        "可以加學校入面任何學生。固定額度只係統一批量設定，唔可以單獨改某個成員。",
      generateLink: "建立完成後產生項目組加入連結",
      linkExpiry: "連結有效期",
      joinQuota: "加入後嘅通用額度",
      day1: "1天",
      day7: "7天",
      day30: "30天",
      pointsUnit: "積分/人",
      step3Tip:
        "若項目可分配積分唔夠，新成員都可以加入，但初始項目額度係 0；管理員補完項目積分之後再統一批量設定。",
      prev: "上一步",
      next: "下一步",
      submit: "建立項目組",
      nameRequired: "請輸入項目組名稱",
      allocateRequired: "請輸入劃入項目積分",
      allocateExceed: "劃入積分唔可以超過建立者可用積分",
      allocateInvalid: "劃入積分必須係大於等於 0 嘅整數",
      quotaRequired: "請輸入每人項目總額度",
      quotaInvalid: "每人額度必須係正整數",
      quotaExceed: "每人項目總額度唔可以超過建立者可用積分",
      success: "項目組已建立",
      failed: "建立項目組失敗",
      noStudent: "搵唔到符合嘅成員",
      membersLoadFailed: "成員列表載入失敗",
      pointsLoadFailed: "建立者可用積分載入失敗",
      accountLevels: {
        admin: "管理員",
        subAdmin: "子管理員",
        member: "成員",
      },
    },
    workbench: {
      title: "項目組工作台",
      subtitle: "集中管理成員、項目積分同作品查看權限",
      backToList: "返回項目組列表",
      searchPlaceholder: "搜尋項目組",
      createCanvas: "建立畫布",
      // 頭部重新整理掣：重拉額度卡同而家呢個 Tab
      refresh: "重新整理",
      topup: "調整積分",
      manageInvite: "管理邀請連結",
      creator: "建立者：{name} · {dept}",
      deptCanvas: "泫宗畫布項目組",
      quotaFixedShort: "額度 {n}/人",
      quotaGiftShort: "贈送 {n}/人",
      quotaExclusiveShort: "獨享 {n}/人",
      stats: {
        // 拆分卡左列：剩餘可用
        available: "剩餘可用積分",
        // 拆分卡右列：項目總額
        total: "項目積分總額",
        // 頂部合併卡：剩餘 / 總額
        availableTotal: "剩餘可用積分/項目積分總額",
        unifiedQuota: "統一額度",
        // 成員模式：總額度減去已消耗
        personalAvailable: "個人可用額度",
        // 統計卡右側：而家登入成員額度，對應 currentMember.quotaLimit
        personalQuota: "個人總額度",
        unifiedPersonal: "統一額度/個人總額度",
        members: "項目成員",
        consumed: "項目累計消耗",
        // 統計卡右側：而家登入成員消耗，對應 currentMember.usedIntegral
        personalConsumed: "個人累計消耗",
        consumedPersonal: "項目累計消耗/個人累計消耗",
        perPerson: "{n} / 人",
        // 統一額度列淨係展示數字，唔再帶「/人」
        perPersonCompact: "{n}",
      },
      // 問號說明：停用按鈕外面都仲可以移入睇
      helpAria: "{label}說明",
      tips: {
        available: "而家項目剩餘可消耗積分。",
        total: "已劃入項目嘅積分總額。",
        availableTotal: "而家項目剩餘可消耗積分 / 已劃入項目嘅積分總額。",
        unifiedQuota: "項目統一設定嘅成員額度。",
        personalAvailable: "而家成員喺呢個項目入面剩餘可用嘅額度。",
        personalQuota: "單個成員實際攞到嘅額度。",
        unifiedPersonal: "前者係項目統一設定嘅成員額度，後者係單個成員實際攞到嘅額度。",
        members: "而家已加入而且未移除嘅成員數量。",
        consumed: "項目全部成員累計消耗。",
        personalConsumed: "單個成員喺項目入面嘅累計消耗。",
        consumedPersonal: "前者係項目全部成員累計消耗，後者係單個成員喺項目入面嘅累計消耗。",
        topup:
          "調整項目組積分總額：可以從建立者可用積分入面加項目積分，亦可以扣減項目入面未消耗積分再退返建立者帳戶；調整之後嘅項目總積分唔可以低過已消耗積分。",
        batchQuota:
          "統一覆蓋而家項目組全部成員嘅額度設定，可以揀固定額度或者不限額；固定額度時所有成員攞同一總額度，已消耗部分唔會受影響。",
        audit: "記錄項目設定、成員管理、額度調整同邀請管理等關鍵操作。",
        status: "控制項目做進行中、暫停、已完畢或者關閉；狀態會影響成員可唔可以繼續生產。",
        // 積分明細成員搜尋：後端淨係按消耗類流水匹配名稱
        searchMemberName: "只支援搜尋積分消耗類型嘅積分明細",
      },
      tabs: {
        members: "成員同額度",
        works: "成員作品",
        points: "積分明細",
        settings: "項目設定",
        // 建立者操作日誌：審計流水 6–18
        audit: "操作日誌",
        // 建立者 / 成員都有我嘅作品；成員另外有我嘅積分明細 / 項目資訊
        myWorks: "我嘅作品",
        myPoints: "我嘅積分明細",
        info: "項目資訊",
      },
      membersHint: "可以管理成員額度同使用狀態；項目積分只限而家呢個項目組用",
      addStudents: "新增成員",
      batchQuota: "批量設定額度",
      columns: {
        member: "成員",
        role: "身份",
        consumedQuota: "已消耗/總額度",
        works: "作品",
        status: "狀態",
        actions: "操作",
        memberName: "成員名稱",
        time: "時間",
        action: "操作",
        // 積分明細：操作右邊展示接口 remark
        operateDetail: "操作明細",
        change: "積分變更",
        // 成員「我的積分明細」：變更列改成消耗
        consume: "消耗",
        type: "類型",
        // 建立者積分明細：同頂部統計卡「剩餘可用積分」
        balance: "剩餘可用積分",
        // 成員「我的積分明細」：對齊個人額度卡
        remainingQuota: "剩餘額度",
        model: "模型",
        resolution: "解像度/清晰度",
        quantity: "時長/數量",
        // 操作日誌：類型 / 內容 / 明細
        operateTime: "操作時間",
        operator: "操作對象",
        operateContent: "操作內容",
        operateType: "操作類型",
        detail: "明細",
      },
      roleMember: "成員",
      roleCreator: "建立者",
      worksCount: "{n} 個作品",
      statusNormal: "正常",
      statusDisabled: "已停用",
      adjustPoints: "調整額度",
      disable: "停用",
      restore: "恢復",
      viewWorks: "查看作品",
      remove: "移除",
      cannotRemoveCreator: "唔可以移除建立者",
      cannotDisableCreator: "唔可以停用建立者",
      cannotAdjustCreator: "唔可以調整建立者額度",
      removeSuccess: "成員已移除",
      removeFailed: "移除成員失敗",
      removeConfirm: {
        title: "確定要移除「{name}」嗎？",
        message: "移除之後呢個成員會失去項目組訪問權限，已消耗積分唔會退回。",
        confirm: "確定移除",
      },
      disableConfirm: {
        title: "確定要停用「{name}」嗎？",
        message: "停用之後呢個成員就唔可以繼續喺而家呢個項目組生產。",
        confirm: "確定停用",
      },
      restoreConfirm: {
        title: "確定要恢復「{name}」嗎？",
        message: "恢復之後呢個成員可以繼續喺而家呢個項目組生產。",
        confirm: "確定恢復",
      },
      worksHint: "建立者可以編輯自己嘅畫布，其他成員作品只支援查看",
      myWorksHint: "只展示我建立嘅作品，可以進入編輯",
      memberWorksHint: "只展示其他成員作品，唯讀查看",
      filterAll: "全部",
      filterEdit: "可編輯",
      filterView: "可查看",
      searchWork: "搜尋畫布/人員名稱",
      searchWorkName: "搜尋作品名稱",
      searchMemberName: "搜尋成員名稱",
      allTypes: "全部類型",
      allTime: "全部時間",
      timeToday: "今日",
      timeWeek: "近 7 日",
      timeMonth: "近 30 日",
      startDate: "開始日期",
      endDate: "結束日期",
      rangeSeparator: "至",
      datePickerFormat: "yyyy/MM/dd",
      workTimeAria: "按建立時間篩選畫布",
      selectTimeRange: "選擇時間範圍",
      datePlaceholder: "年 / 月 / 日",
      clearTimeRange: "清空",
      incompleteTimeRange: "請選擇開始日期同結束日期",
      startAfterEnd: "開始日期唔可以大過結束日期",
      typeCanvas: "畫布作品",
      typeStoryboard: "分鏡作品",
      typeImage: "圖片作品",
      createdAt: "建立於 {time}",
      workAuthorTime: "{name} · {time}",
      readOnlyView: "可查看",
      enterEdit: "可編輯",
      emptyWorks: "暫時未有成員作品",
      emptyMyWorks: "暫時未有作品",
      emptyGroups: "搵唔到符合嘅項目組",
      dash: "--",
      todayTime: "今日 {time}",
      justNow: "頭先",
      settingsStatusTitle: "項目狀態",
      settingsStatusHint: "設定項目組而家階段；暫停之後可以重新恢復做進行中。",
      info: {
        groupName: "項目組名稱",
        status: "項目狀態",
        creator: "建立者",
        quotaMode: "額度模式",
        hint: "項目額度只限而家呢個項目用。你可以編輯自己嘅作品，並以唯讀方式查看其他成員作品。",
      },
      statusRunningTitle: "進行中",
      statusRunningDesc: "預設狀態，成員可以正常生產",
      statusPausedTitle: "暫停",
      statusPausedDesc: "暫時停止成員繼續生產",
      statusFinishedTitle: "已完畢",
      statusFinishedDesc: "項目工作已完成，可以繼續查看內容",
      statusClosedTitle: "關閉項目",
      statusClosedDesc: "關閉生產並結束而家呢個項目組",
      settingsSaved: "項目設定已更新",
      statusChanged: "項目狀態已更換做「{status}」",
      statusClosedSuccess: "已關閉項目",
      statusChangeFailed: "項目狀態更新失敗",
      statusFinishedLocked: "而家呢個項目組而家階段已完畢，唔可以再改狀態",
      statusFinishedActionLocked: "而家呢個項目組已完畢，唔可以做呢個操作",
      statusPausedActionLocked: "而家呢個項目組已暫停，唔可以做呢個操作",
      statusClosedLocked: "而家呢個項目組而家階段已關閉，唔可以再改狀態",
      statusClosedActionLocked: "而家呢個項目組已關閉，唔可以做呢個操作",
      closeConfirm: {
        title: "確認關閉項目",
        subtitle: "呢個操作會改項目組嘅生產狀態",
        bodyLead: "關閉之後成員就唔可以繼續生產。",
        bodyFollow:
          "未消耗積分會按正式業務規則退返創建者帳戶，請確認係咪關閉而家呢個項目。",
        confirm: "確認關閉項目",
      },
      finishConfirm: {
        title: "確認標記為已完畢",
        subtitle: "呢個操作會改項目組嘅生產狀態",
        body: "標記為已完畢之後就唔可以再切換項目狀態，請確認工作已經完成。",
        confirm: "確認標記為已完畢",
      },
      disableSuccess: "成員已停用",
      restoreSuccess: "成員已恢復",
      disableFailed: "停用成員失敗",
      restoreFailed: "恢復成員失敗",
      notFound: "搵唔到呢個項目組",
      fetchDetailFailed: "取得項目組詳情失敗",
      // 成員模式撳畫布 / 建立前發現已被停用或移出
      memberAccessBlocked: {
        disabledTitle: "無法繼續操作",
        disabledMessage: "你已被停用，無法繼續喺而家呢個項目組生產",
        removedTitle: "無法繼續操作",
        removedMessage: "你已被移出項目組，無法繼續訪問而家呢個項目組",
        confirm: "返回項目組列表",
      },
      fetchWorksFailed: "取得組內畫布失敗",
      fetchLedgerFailed: "取得積分明細失敗",
      emptyLedger: "暫無數據",
      fetchAuditFailed: "取得操作日誌失敗",
      emptyAudit: "暫無數據",
      // 操作日誌篩選 / 類型列分組
      audit: {
        settings: "項目設定",
        member: "成員管理",
        quota: "額度調整",
      },
      batch: {
        title: "批量設定成員額度",
        subtitle: "呢個設定會統一覆蓋全部 {count} 名成員",
        quotaMode: "額度模式",
        quotaPerPerson: "每人項目積分總額度",
        hint: "總額度唔可以低過而家非管理員成員已消耗嘅最高積分。若成員已消耗 50 積分，總額度改做 200 之後剩 150。",
        confirm: "確認批量設定",
        quotaBelowConsumed: "每人項目總額度唔可以低過而家非管理員成員已消耗嘅最高積分（{n}）",
        quotaExceed: "每人項目總額度唔可以超過建立者總積分+項目總積分",
        success: "成員額度已批量更新",
        failed: "批量設定成員額度失敗",
      },
      topupDialog: {
        title: "調整項目積分",
        desc: "可以從建立者帳戶劃入積分，都可以將未消耗積分退回",
        opType: "操作類型",
        opAdd: "增加積分",
        opReduce: "退回積分",
        creatorAvailable: "建立者可用積分",
        projectTotal: "項目而家總積分",
        projectConsumed: "項目已消耗積分",
        projectRemaining: "項目而家剩餘積分",
        amount: "今次調整數量",
        afterTotal: "調整後項目總積分",
        afterRemaining: "調整後剩餘積分",
        confirm: "確認調整",
        success: "項目積分已補充",
        successReduce: "未消耗積分已退回建立者帳戶",
        failed: "項目積分劃入失敗",
        failedReduce: "項目積分退回失敗",
        invalid: "調整數量必須係正整數",
        exceed: "增加積分唔可以超過建立者可用積分",
        exceedReduce: "退回積分唔可以超過項目而家剩餘積分",
      },
      invite: {
        title: "項目組邀請連結",
        desc: "連結有效，可以直接複製分享",
        descExpired: "連結已過期，請重新生成之後再分享",
        descExpiryChanged: "有效期已更改，要重新生成之後先可以分享",
        quota: "通用額度",
        quotaValue: "{n} 積分/人",
        expiry: "有效期",
        hour24: "24小時",
        hour72: "72小時",
        link: "邀請連結",
        hint: "連結會繼承項目組嘅統一額度模式。項目積分唔夠時，新成員都可以加入。",
        preview: "預覽加入流程",
        copy: "複製連結",
        regenerateAndCopy: "重新生成連結並複製",
        copied: "邀請連結已複製",
        regeneratedCopied: "新邀請連結已生成並複製",
        copyFailed: "複製失敗",
        generateFailed: "邀請連結生成失敗",
        loadFailed: "邀請連結查詢失敗",
      },
      join: {
        title: "{name} 嘅加入邀請",
        subtitle: "業務員視角，撳完之後加入項目組",
        projectType: "項目類型",
        joinQuota: "加入後額度",
        quotaValue: "{n} 積分",
        group: "所屬項目組",
        permission: "作品權限",
        permissionValue: "自己嘅可以編輯，其他人只讀",
        pointsHint:
          "項目積分只可以喺呢個項目組入面用，退出項目組或者入其他項目都唔可以用。",
        confirm: "確認加入項目組",
        success: "已加入項目組",
      },
      invitePage: {
        badge: "項目邀請",
        title: "邀請你加入項目組",
        summary:
          "{enterprise}嘅 {inviter} 邀請你加入項目組「{project}」。請喺{deadline}前確認，過期之後邀請連結會失效。",
        enterprise: "企業名稱",
        inviter: "邀請人",
        projectName: "項目組名稱",
        deadline: "截止時間",
        deadlineLocal: "{date} {time}",
        deadlineEn: "{time} on {date}",
        agreeHint:
          "同意之後，你會成為呢個項目組成員，並用項目組分配嘅額度去創作。",
        agree: "同意加入",
        enter: "進入項目組",
        invalid: "邀請連結已失效，請聯絡邀請人重新獲取",
        alreadyMember: "你已經係呢個項目組成員，唔使再加入",
        joinSuccess: "已加入項目組",
        joinFailed: "加入項目組失敗，請稍後再試",
        loadFailed: "邀請確認頁資料載入失敗，請稍後再試",
        empty: "—",
      },
      canvasDialog: {
        title: "建立項目畫布",
        desc: "畫布會歸屬而家呢個項目組，積分只會從項目組額度消耗",
        name: "畫布名稱",
        defaultName: "未命名畫布",
        hint: "建立之後會產生空白畫布。建立者可以編輯；管理員、子管理員同項目入面其他成員只讀查看。",
        confirm: "確認建立畫布",
        success: "畫布已建立",
        failed: "建立畫布失敗",
        nameRequired: "請輸入畫布名稱",
      },
      renameDialog: {
        title: "修改項目組名稱",
        desc: "儲存之後側欄同工作台會同步展示新名稱",
        name: "項目組名稱",
        namePlaceholder: "請輸入項目組名稱",
        confirm: "儲存名稱",
        success: "項目組名稱已更新",
        failed: "修改項目組名稱失敗",
        nameRequired: "請輸入項目組名稱",
        aria: "修改項目組名稱",
      },
      addStudent: {
        title: "新增成員",
        tip: "可以按組織批量勾選，加入之後統一套用額度",
        confirm: "確認新增",
        success: "成員已加入項目組",
        successWithRemove: "成員列表已更新",
        noneSelected: "請揀要新增嘅成員",
        failed: "新增成員失敗",
        removeConfirm: {
          title: "確定移除已取消勾選嘅成員嗎？",
          message:
            "共 {count} 人會被移出項目組，移除之後會失去訪問權限，已消耗積分唔會退回。",
          confirm: "確定移除",
        },
      },
      adjust: {
        title: "調整成員額度",
        subtitle: "{name} · 只調整而家呢個項目組入面可用額度",
        member: "成員",
        current: "已消耗 / 總額度",
        newQuota: "新嘅總額度",
        hint: "總額度唔可以低過呢個成員已消耗積分。若成員已消耗 50 積分，總額度改做 200 之後剩 150。",
        opType: "操作類型",
        opAdd: "添加額度",
        opReduce: "減少額度",
        amount: "調整數量",
        consumed: "而家已消耗",
        currentTotal: "而家總額度",
        afterTotal: "調整後總額度：{n} 積分",
        confirm: "確認調整",
        success: "成員額度已更新",
        failed: "成員額度調整失敗",
        invalid: "總額度必須係非負整數",
        resultInvalid: "調整後總額度唔可以係負數",
        belowConsumed: "調整後總額度唔可以少過成員已消耗額度",
        exceed: "調整額度唔可以超過建立者總積分+項目總積分",
      },
      ledger: {
        transferIn: "項目積分劃入",
        transferOut: "項目積分退回",
        canvasGenerate: "畫布生成",
        storyboardGenerate: "分鏡生成",
        credit: "項目入賬",
        refund: "項目退回",
        consume: "成員消耗",
        modelTumeng: "圖夢 3.0",
        res2k: "2K / 高清",
        quantityImages: "{n} 張",
        durationSeconds: "{n}秒",
      },
    },
  },
  visionCanvas: {
    title: "我的畫布",
    subtitle: "呢個畫布入面嘅項目組、成員、積分會獨立管理",
    createTime: "建立時間",
    searchPlaceholder: "搜尋項目名稱",
    createProject: "新建項目",
    loading: "載入中...",
    empty: "暫無畫布項目",
    emptyTip: "建立你嘅第一個畫布項目開始創作",
    emptyNotFound: "搵唔到匹配項目",
    emptyHint: "試吓其他關鍵詞搜尋",
    open: "打開",
    rename: "重新命名",
    delete: "刪除",
    enterProject: "進入項目",
    editMode: "可編輯",
    viewMode: "只睇",
    filterAll: "全部",
    filterView: "可查看",
    emptyFilterHint: "試吓切換篩選條件",
    createTimeLabel: "建立時間：{date}",
    creatorLabel: "創作者：{name}",
    untitled: "未命名",
    dateFormat: "{year}年{month}月{day}日",
    fetchListFailed: "取得項目列表失敗",
    renameSuccess: "重新命名成功",
    operationFailed: "操作失敗",
    deleteConfirm: "確定刪除項目「{name}」嗎？",
    deleteTitle: "刪除項目",
    cancel: "取消",
    deleteSuccess: "刪除成功",
    deleteFailed: "刪除失敗",
    pleaseLogin: "請先登入",
    loadFailed: "無限畫布載入失敗，請確認 manshu-ui 已啟動（{entry}）",
  },
  statisticalDimension: {
    title: "統計維度",
    loading: "數據載入中",
    search: "搜尋",
    clear: "清除",
    apply: "套用",
    exportTable: "匯出表格",
    exporting: "匯出中...",
    exportSuccess: "表格已匯出",
    exportFailed: "匯出失敗",
    exportFailedRetry: "匯出失敗，請稍後再試",
    exportFallback: "匯出",
    unknown: "未知",
    none: "暫無",
    noData: "暫無數據",
    pageInfo: "第 {page} / {total} 頁",
    tipAria: "{label}說明",
    serverError: "伺服器內部錯誤，請稍後再試",
    searchLabel: "搜尋：",
    filterLabel: "篩選：",
    projectLabel: "項目：",
    operatorLabel: "操作人：",
    points: "積分",
    pointsSpace: " 積分",
    pointsPerSec: "積分/s",
    pointsPerSecValue: "{value} 積分/s",
    pointsPerImage: "積分/張",
    times: "次",
    pieces: "個",
    images: "張",
    people: "{count} 人",
    projectsCount: "{count} 個項目",
    segmentsCount: "{count} 個片段",
    timesPoints: "{count}次 / {points}積分",
    imageVideoCount: "{image} 圖 {video} 影片",
    countUnit: "{n}個",
    wan: "{n}萬",
    duration: {
      seconds: "{n}秒",
      minutesSeconds: "{m}分{s}秒",
      minutesOnly: "{m}分鐘",
    },
    tabs: {
      overview: "概覽",
      project: "工作流項目",
      segment: "漫劇片段",
      canvas: "無限畫布",
      member: "成員明細",
    },
    time: {
      range: "時間範圍",
      current: "現在：",
      compare: "對比：",
      startDate: "開始日期",
      endDate: "結束日期",
      selectStartDate: "選擇開始日期",
      selectEndDate: "選擇結束日期",
      custom: "自訂",
      month: "本月",
      lastMonth: "上月",
      all: "全部時間",
      compareLastMonth: "上月",
      compareBeforeLastMonth: "上上月",
      previousPeriod: "上個週期",
      startAfterEnd: "開始日期唔可以大過結束日期",
      yearMonth: "{year}年{month}月",
      yearMonthFormat: "yyyy年M月",
    },
    filter: {
      canvasSearchAria: "搜尋畫布名稱或建立者",
      canvasSearchPlaceholder: "輸入畫布名稱或建立者...",
      projectSearchAria: "搜尋項目名稱",
      projectSearchPlaceholder: "輸入項目名稱搜尋...",
      projectFilterAria: "篩選片段所屬項目",
      projectFilterPlaceholder: "輸入項目名稱...",
      operatorFilterAria: "篩選片段操作人",
      operatorFilterPlaceholder: "輸入操作人...",
      memberFilterAria: "篩選成員或項目",
      memberFilterPlaceholder: "輸入成員/項目名稱...",
      memberProjectSearchAria: "搜尋成員項目",
      canvasProjectSearchAria: "搜尋畫布項目",
      searchProjectPlaceholder: "搜尋項目...",
      clearProjectFilter: "清除項目篩選",
    },
    overview: {
      totalConsumption: "總積分消耗（漫劇 + 畫布）",
      dramaProject: "漫劇項目",
      canvasProject: "畫布項目",
      consumptionTrend: "積分消耗趨勢",
      pointsConsumption: "積分消耗",
      projectCount: "項目數",
      imageWasteRate: "圖片廢棄率",
      videoWasteRate: "影片廢棄率",
      generateCount: "生成次數",
    },
    stats: {
      totalPoints: "總積分消耗",
      totalDuration: "總項目時長",
      totalImages: "總項目圖片",
      avgPerSegment: "均每片段積分",
      videoPerSec: "影片每秒消耗",
      imagePerPiece: "圖片每張消耗",
      tipDuration: "實際使用影片嘅有效時長",
      tipAvgSegment: "片段總消耗積分 ÷ 片段數",
      tipVideoPerSec: "實際消耗積分 ÷ 有效時長",
      tipImagePerPiece: "實際消耗積分 ÷ 有效數量",
      comparedTo: "較{period}",
    },
    operation: {
      video: "影片生成",
      image: "圖片生成",
      script: "劇本解析",
    },
    asset: {
      character: "人物",
      scene: "場景",
      prop: "道具",
      unit: "個",
    },
    detail: {
      pointsTypeDistribution: "積分類型分佈",
      videoStats: "影片統計",
      imageStats: "圖片統計",
      collaboration: "協作明細",
      costPoints: "消耗積分",
      segmentDuration: "片段時長",
      budget: "預算",
      diff: "差異",
      remainingPrefix: "剩餘 ",
      overspendPrefix: "超支 ",
      remaining: "剩餘 {value}",
      overspend: "超支 {value}",
      avgPerSec: "均每秒消耗",
      operator: "操作人",
      effectiveDuration: "有效時長",
      actualGenerate: "實際生成",
      wasteRate: "廢棄率",
      effectiveCount: "有效數量",
      effective: "有效",
      actual: "實際",
      cost: "消耗",
      video: "影片",
      image: "圖片",
      text: "文",
      total: "合計",
      costPointsValue: "{value} 積分",
      imagesValue: "{value} 張",
    },
    project: {
      backToList: "‹ 返回項目列表",
      ranking: "漫劇項目排行",
      consumptionTrend: "積分消耗趨勢",
      dataDistribution: "數據分佈",
      operationDistribution: "操作類型分佈",
      assetDistribution: "資產分佈",
      totalConsumption: "總消耗",
      totalAssets: "資產總數",
      emptyTitle: "暫無匹配項目",
      emptyDesc: "調整搜尋條件後再試",
      emptyCollaborators: "暫無協作明細",
      tipImageCount: "實際使用嘅有效圖片數量",
      tipVideoDuration:
        "影片時長代表生成影片入面被使用嘅有效時長，所有影片欄位統一",
      columns: {
        name: "項目名稱",
        scriptNum: "集數",
        scriptDuration: "每集時長",
        segments: "片段數",
        members: "成員數",
        duration: "影片時長",
        imageCount: "圖片數",
        total: "消耗積分",
        budget: "預算",
        diff: "差異",
        progress: "進度",
      },
    },
    segment: {
      title: "漫劇片段",
      backToList: "‹ 返回片段列表",
      emptyTitle: "暫無匹配片段",
      emptyDesc: "調整篩選條件後再試",
      ofTotal: "佔總消耗 {percent}%",
      missingScriptId: "而家呢個片段缺少 scriptId，查唔到詳情",
      detailFailed: "取得片段詳情失敗，請稍後再試",
      columns: {
        name: "片段名稱",
        project: "所屬項目",
        scriptDuration: "本集時長",
        duration: "片段時長",
        cost: "消耗積分",
        perSecond: "每秒消耗",
        operator: "操作人",
      },
    },
    canvas: {
      listTitle: "畫布項目列表",
      emptyTitle: "暫無畫布項目",
      emptyDesc: "調整搜尋條件後再試",
      columns: {
        name: "畫布名稱",
        creator: "建立者",
        imageGenerate: "圖片生成",
        videoGenerate: "影片生成",
        lastOperateTime: "最近操作",
      },
    },
    member: {
      title: "成員明細管理",
      emptyTitle: "暫無匹配成員",
      emptyDesc: "調整搜尋條件後再試",
      backToList: "‹ 返回成員列表",
      participateSummary: "參與 {projects} 個項目 · 完成 {segments} 個片段",
      projectConsumption: "各項目消耗",
      dramaProject: "漫劇項目",
      canvasProject: "畫布項目",
      costAllProjects: "消耗積分(所有參與項目)",
      avgPerSec: "均/每秒消耗",
      costPerImage: "圖片每張消耗",
      efficiency: "效率評級",
      efficiencyNormal: "正常",
      operationRatio: "操作類型佔比",
      dramaProjects: "各漫劇項目",
      canvasProjects: "各畫布項目",
      noMatchProject: "暫無匹配項目",
      noProject: "暫無項目",
      dailyTrend: "每日消耗趨勢 — {project} · {period}",
      generateTrend: "生成消耗趨勢 — {project} · {period}",
      segmentTitle: "漫劇片段 — {project}",
      generateDetail: "生成明細",
      imageGen: "圖片生成",
      videoGen: "影片生成",
      columns: {
        name: "成員",
        projects: "所屬項目",
        used: "已消耗",
        remaining: "剩餘積分",
        allocated: "分配積分",
        progress: "進度",
        segment: "片段",
        script: "劇本解析",
        image: "圖片生成",
        imageCount: "圖片數",
        video: "影片生成",
        videoDuration: "影片時長",
        total: "合計",
        canvasName: "畫布名稱",
        creator: "建立者",
      },
    },
    export: {
      projectFile: "漫劇項目_{label}.xlsx",
      segmentFile: "漫劇片段_{label}.xlsx",
      canvasFile: "畫布項目_{label}.xlsx",
      memberFile: "成員明細.csv",
    },
  },
};
